import React, {CSSProperties, forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState} from "react";
import {
    DndContext,
    KeyboardSensor,
    MouseSensor,
    TouchSensor,
    closestCenter,
    type DragEndEvent,
    useSensor,
    useSensors, DragStartEvent, DragMoveEvent, DragOverEvent,
} from '@dnd-kit/core'
import { restrictToHorizontalAxis } from '@dnd-kit/modifiers'
import {
    arrayMove,
    SortableContext,
    horizontalListSortingStrategy,
} from '@dnd-kit/sortable'
import {
    Cell,
    ColumnDef,
    ColumnResizeDirection,
    ColumnResizeMode,
    Header,
    flexRender,
    getCoreRowModel,
    useReactTable,
} from '@tanstack/react-table'
import { useVirtualizer } from '@tanstack/react-virtual';

// needed for row & cell level scope DnD setup
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import './TableView.css'
import {
    batchUpdateProject, getNoteById,
    getNoteDoc,
    getNoteJsonDoc,
    getNoteList, getProjectById,
    getProjectByTagName,
    updateNote,
    updateProject
} from "@model/note";
import {
    batchUpdateCard,
    getCardById,
    getCardByTagName,
    getCardDoc,
    getLibraryByLibraryId,
    updateCard
} from "@model/card";
import {
    checkIfAbsolute,
    containsAllEvery,
    createCopyLinkByLibraryItem, createDeeplink, decodeDeeplink, filterNumericInput,
    formatDate, formatDateCharDesc, formatDateHms,
    generateUUID2,
    getImagePathWithTheme,
    getImagePathWithThemeSvg, getItem, getSafeFloat, getSafeInt, getTimeText, isAnnoType,
    isArray, isBilibiliUrl,
    isDarkMode, isDeepLink, isIntType, isNumber, isNumberOrFloat, isObject, isString, removeHtmlTags
} from "@/utils";
import {
    createDeeplinkView, deepLinkToLinkInfo,
    getCardTitle,
    getDrawPath,
    getImageNameFromdeepLinkType, isMac, isSupportLink, openUrlOrLocalPath,
    updateFavorToFolder
} from "@/Utility";
import {
    ARRAY_LIBRARY_TYPES_TABLEVIEW,
    ARRAY_PROPERTY_OPTIONS_COLOR,
    ARRAY_PROPERTY_TYPE, CHECK_ALL,
    DEFAULT_DARK_TAG_BACKGROUND_COLOR, DEFAULT_PROPERTY,
    DEFAULT_TAG_BACKGROUND_COLOR,
    EVENT_FAVIRIATE_CHANGE,
    EVENT_OPEN_LIBRARY_ITEM,
    EVENT_RESET_NO_SELECTED,
    EVENT_SHOW_DIALOG_DRAWINDEX,
    FROM_DIALOG,
    FROM_LIBRARY,
    GET_ARRAY_LIBRARY_TYPES,
    getDefaultTagBackgroundColor,
    getPropertySelectOptionBackgroundColor,
    KEY_FILE_DIR, KEY_IS_FIRST_OPEN_LIBRARY_REF, MAP_COLUMN_DATAS,
    MAP_GROUP_BACKGROUND_COLOR,
    MAP_MONTH,
    MAP_MONTH_FULL, MENU_SEPARATOR
} from "@/Const";
import {t} from "i18next";
import {getViewById, getViewList, updateView} from "@model/view";
import {findNodeWithParents, loop, loopAllNode, loopAllNodeWithReturn} from "@/TreeUtils";
import {postMessage} from "@/common/event";
import {getTagList} from "@model/tag";
import {IconChangeSource, IconIndicatorBlue, IconIndicatorWhite} from "@/Icon";
import {message, Popover, Select, Spin, Tag,Checkbox, Dropdown, Tooltip,type MenuProps} from "antd";
import {marginLeft} from "html2canvas/dist/types/css/property-descriptors/margin";
import {ipcInvoke} from "@/common/ipc";
import {getPropertyById, getPropertyList, updateProperty} from "@model/Property";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import PopupDate from "@/views/Property/PopupDate";
import global from "@/global";
import {getTagBackgroundIndex, setTagBackgroundIndexAdd} from "@/LocalStroageUtils";
import {createBoardItemMenu, createBoardMenu, createLibraryItemMenu, createProjectItemMenu} from "@/MenuUtils";
import {onBoardItemClick, onCardItemClick, onProjectItemClick} from "@/views/Library/HandleLibraryItemUtils";
import {formatTime} from "@/bilibiliUtils";
import CustomDeeplink from "@/views/Property/CustomDeeplink";
import {batchUpdateBoard, getBoardById, getBoardByTagName, updateBoard} from "@model/board";
import PropertyContentInfo from "@/views/Property/PropertyContentInfo";
import clipboard from "clipboardy";
import {readSystemClipboard} from "../../../@excalidraw/packages/excalidraw/clipboard";

const mDatasMap:any = {};
const COLUMN_WIDTH_CHECKED = 42;
const TableView = forwardRef((props:{tableView:any,tagName:any,szSearchKey:any,onRefreshCheck:any,addNewPropertyToTableView:any,onRefreshCount:any,onNewRow:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onRefreshData:refreshData,
        doSearch:doSearch,
        onAddItem:onAddItem,
        onResetChecked:onResetChecked,
        onDeleteSelect:onDeleteSelect,
        onClearRowCheckedIds:onClearRowCheckedIds,
        onUpdateSelectValue:onUpdateSelectValue,
        onGetSelectItems:onGetSelectItems,
        onGetData:onGetData,
        onGetThatAllTags:onGetThatAllTags,
        onResetSearch:onResetSearch
    }))

    const sensors = useSensors(
        useSensor(MouseSensor, {}),
        useSensor(TouchSensor, {}),
        useSensor(KeyboardSensor, {})
    )


    props.tableView.data = mDatasMap[props.tagName] || [];

    const divTableContainerRef = useRef(null);
    const [tableData,setTableData] = useState(props.tableView);
    const [columnResizeMode, setColumnResizeMode] =
        React.useState<ColumnResizeMode>('onChange')
    const [columnResizeDirection, setColumnResizeDirection] =
        React.useState<ColumnResizeDirection>('ltr')
    const [isLoading,setIsLoading] = useState(false);
    const mIsLoading = useRef(false);
    const [columnSizing, setColumnSizing] = useState<any>({});
    const [rowChecked,setRowChecked] = useState<any>({});
    const mLastViewId = useRef(null);
    const [mapIsColumnMoreOpen,setMapIsColumnMoreOpen] = useState<any>({});
    const [menuItems,setMenuItems] = useState<MenuProps['items']>([]);
    const [mapSelectOpen,setMapSelectOpen] = useState<any>({});
    const mMapSelectOpenRef = useRef<any>({})
    const [isAddPropertyOpen, setIsAddPropertyOpen] = useState(false);

    const mArrayTags = useRef(null);
    const mTableviewDataRef = useRef(props.tableView);
    const mArrayMenuItems = useRef<any>([]);
    const mCurrentMoreData = useRef<any>(null);//当前右键的更多数据
    const mCreateNewSelectBackgroundColorIndex = useRef<any>(-1);
    const mszSearchKeyRef = useRef<any>(null);
    const mEmptyColumnWidth = useRef<any>(0);
    const mRowCheckedRef = useRef<any>({});

    const getImportMenu = ()=>{
        const menu = [
            getItem(<div style={{minWidth:'160px'}}>{t("Import project")}</div>, 'importProject', null, undefined, undefined, () => {
                window.importProject((project)=>{
                    //添加标签.
                    project.tags = [props.tagName];
                    project.type = 'project';
                    updateProject(project).then(res=>{
                        addItemToView(project);
                    })
                });
            }),
            getItem(t("Import markdown"), 'importMarkdown', null, undefined, undefined, () => {
                window.importMarkdownMultiple((arrayCards)=>{
                    for (let i=0;i<arrayCards.length;i++){
                        arrayCards[i].tags = [props.tagName];
                    }
                    batchUpdateCard(arrayCards).then(res=>{
                        addItemToView(arrayCards);
                    })
                })
            }),
        ]
        return menu;
    }

    const ARRAY_PROPERTY_ADD_ITEM = () => {
        const menu = [
            getItem(<div className={'flex-row-vertical-center'}>{t("New row")}<span
                style={{marginLeft: 'auto', color: 'var(--text-color-bab8b8)'}}>R</span>
            </div>, 'newRow', null, undefined, undefined, () => {
                //增加一个卡片
                props.onNewRow();
            }),
            getItem(<div className={'flex-row-vertical-center'}>{t("New card")}<span
                style={{marginLeft: 'auto', color: 'var(--text-color-bab8b8)'}}>C</span>
            </div>, 'newItem', null, undefined, undefined, () => {
                //增加一个卡片
                const newCard = {
                    id: generateUUID2(),
                    name: '',
                    createTime: Date.now(),
                    updateTime: Date.now(),
                    isDeleted: 0,
                    type: 'card',
                    tags: [props.tagName],
                }
                updateCard(newCard).then(res => {
                    window.showDialogCard(res);
                })

            }),
            getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

            }),
            getItem(t("New PDF"), 'newPdf', null, undefined, undefined, () => {
                window.showDialogLibraryImport('pdf',(item)=>{
                    //添加tag,并且添加到列表
                    item.tags = [props.tagName]
                    updateCard(item).then(res=>{
                        addItemToView(res);
                    })
                });
            }),
            getItem(t("New video"), 'newVideo', null, undefined, undefined, () => {
                window.showDialogLibraryImport('video',(item)=>{
                    //添加tag,并且添加到列表
                    item.tags = [props.tagName]
                    updateCard(item).then(res=>{
                        addItemToView(res);
                    })
                });
            }),
            getItem(t("New image"), 'newImage', null, undefined, undefined, () => {
                window.showDialogLibraryImport('image',(item)=>{
                    //添加tag,并且添加到列表
                    item.tags = [props.tagName]
                    updateCard(item).then(res=>{
                        addItemToView(res);
                    })
                });
            }),
            getItem(t("New file"), 'newFile', null, undefined, undefined, () => {
                window.showDialogLibraryImport('file',(item)=>{
                    //添加tag,并且添加到列表
                    item.tags = [props.tagName]
                    updateCard(item).then(res=>{
                        addItemToView(res);
                    })
                });
            }),
            getItem(t("New weblink"), 'newWeblink', null, undefined, undefined, () => {
                window.showDialogWeblinkImport((item)=>{
                    //添加tag,并且添加到列表
                    item.tags = [props.tagName]
                    updateCard(item).then(res=>{
                        addItemToView(res);
                    })
                });
            }),
            getItem(t("Import"), 'import', null, getImportMenu(), undefined, () => {

            }),
            getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

            }),
            getItem(t("From library"), 'fromLibrary', null, undefined, undefined, () => {
                //library 弹窗
                window.showDialogLink('', 'card', (item) => {
                    if (isDeepLink(item)) {
                        const deeplink = decodeDeeplink(item);
                        if (deeplink.type == 'project') {
                            getNoteById(deeplink.id, false).then((res: any) => {
                                if (!isArray(res.tags)) {
                                    res.tags = [];
                                }
                                if (res.tags.includes(props.tagName)) {
                                    message.error(t('DataExists'));
                                } else {
                                    res.tags.push(props.tagName);
                                    updateProject(res).then(rrr => {
                                        onAddItem(res);
                                    });
                                }
                            })
                        } else if (deeplink.type == 'library' || deeplink.type == 'highlight') {
                            let szId = deeplink.id;
                            if (deeplink.type == 'highlight') {
                                szId = deeplink.childId;
                            }
                            getCardById(szId).then((res: any) => {
                                if (!isArray(res.tags)) {
                                    res.tags = [];
                                }
                                if (res.tags.includes(props.tagName)) {
                                    message.error(t('DataExists'));
                                } else {
                                    res.tags.push(props.tagName);
                                    updateCard(res).then(rrr => {
                                        if (res.type == 'card' && (Date.now() - res.createTime) < 2000) {
                                            window.showDialogCard(res);
                                        } else {
                                            onAddItem(res);
                                        }
                                    })
                                }
                            })
                        }
                    }

                })
            }),
        ]
        return menu;
    }


    function onMouseDown(event){
        if (event.target.className.includes('ant-modal-wrap')){
            return;
        }
        if (window.closeEditable){
            window.closeEditable();
        }
    }


    useEffect(()=>{
        getTagList().then(res=>{
            mArrayTags.current = res;
        })
        //每次进来，第一个要更新一下。因为有些新增加的数据，没有前面添加过的这些属性.!!!!--这里确保新增加进来的数据有这个属性。
        global.g_tableviewUpdateProperty = true;

        document.body.addEventListener('mousedown',onMouseDown);
        return ()=>{
            document.body.removeEventListener('mousedown',onMouseDown);
        }
    },[])

    useEffect(() => {
        mIsLoading.current = isLoading;
    }, [isLoading]);

    useEffect(()=>{
        //默认的数据
        refreshData();
    },[props.tableView])

    useEffect(() => {
        mTableviewDataRef.current = tableData;
        if (props.onRefreshCount){
            props.onRefreshCount(tableData.data.length);
        }
        window['refresh_tableview_'] = refreshData;
        window.refreshList['refresh_tableview_tag_'+props.tableView?.id] = refreshTag;
        window.refreshList['refresh_tableview_single_data_'+props.tableView?.id] = refreshSingleData;
        window.refreshList['refresh_column_select_option_'+props.tableView?.id] = refreshColumnSelect;
        return ()=>{
            delete window['refresh_tableview_'];
            delete window.refreshList['refresh_tableview_tag_'+props.tableView?.id];
            delete window.refreshList['refresh_tableview_single_data_'+props.tableView?.id];
            delete window.refreshList['refresh_column_select_option_'+props.tableView?.id];
        }
    }, [tableData]);

    useEffect(() => {
        //列宽拖动完成？？？保存.
        const newView = {...props.tableView};
        const arrayKeys = Object.keys(columnSizing);
        for (let i=0;i<arrayKeys.length;i++){
            const column = newView.columns.find(p=>p.id == arrayKeys[i]);
            if (column){
                column.width = columnSizing[arrayKeys[i]];
                // if (column.type == 'rating'){
                //     if (column.width < 170){
                //         column.width = 170;
                //         columnSizing[arrayKeys[i]] = 170;
                //     }
                // }
            }
        }
        //保存..
        updateView(newView);

    }, [columnSizing]);

    useEffect(() => {
        mMapSelectOpenRef.current = mapSelectOpen;
    }, [mapSelectOpen]);

    useEffect(() => {
        mRowCheckedRef.current = rowChecked;
    }, [rowChecked]);

    /**
     * 添加进来....
     * @param newItem
     */
    const addItemToView = (newItem:any)=>{
        onAddItem(newItem)
    }


    const [columnOrder, setColumnOrder] = React.useState<string[]>(() =>{
        const arrayDefaults:any = [];
        for (let i=0;i<props.tableView.columns.length;i++){
            arrayDefaults.push(props.tableView.columns[i].id);
        }
        return arrayDefaults;
    })

    const table = useReactTable({
        data:tableData.data,
        columns:tableData.columns,
        getCoreRowModel: getCoreRowModel(),
        state: {
            columnOrder,  //列头排序---
            columnSizing,
        },
        columnResizeMode: columnResizeMode,
        onColumnSizingChange: (columnSizing)=>{
            const newSize = columnSizing instanceof Function ? columnSizing(table.getState().columnSizing) : columnSizing;
            // 遍历 newSize，检查每列是否小于 min-width，如果是则修正
            let nTotalWidth = 0;
            const nMaxWidth = divTableContainerRef.current?.offsetWidth;
            Object.keys(newSize).forEach(key => {
                const col = table.getColumn(key);
                let minWidth = 120;
                if (col?.columnDef?.type == 'rating'){
                    minWidth = 170;
                }
                if (newSize[key] < minWidth) {
                    newSize[key] = minWidth;
                }
                if (key == 'checked'){
                    newSize[key] = COLUMN_WIDTH_CHECKED;
                }

                if (col?.id !== 'empty'){
                    nTotalWidth += newSize[key];
                }
            });
            let nWidth = nMaxWidth - nTotalWidth;
            if (nWidth < 0){
                nWidth = 0;
            }
            newSize['empty'] = nWidth;

            mEmptyColumnWidth.current = newSize['empty'];

            setColumnSizing(newSize); // 假设你用 state 管理
        },
        onColumnOrderChange: setColumnOrder,
        debugTable: true,
        debugHeaders: true,
        debugColumns: true,
    })

    const rowVirtualizer = useVirtualizer({
        count: table.getRowModel().rows.length,
        getScrollElement: () => divTableContainerRef.current,
        estimateSize: () => 36, // 估计行高
        overscan: 6, // 预渲染的行数
    });

    const virtualRows = rowVirtualizer.getVirtualItems();
    const totalSize = rowVirtualizer.getTotalSize();

    // 添加 padding 到表格顶部
    // const paddingTop = virtualRows.length > 0 ? virtualRows[0]?.start || 0 : 0;
    // const paddingBottom =
    //     virtualRows.length > 0
    //         ? totalSize - (virtualRows[virtualRows.length - 1]?.end || 0)
    //         : 0;


    const getHeaderColumnIcon = (header)=>{
        return header.column.columnDef?.icon
    }

    /**
     * 获取列和数据的对应关系
     * @param columnName
     */
    function getColumnDataRef(columnName){
        return MAP_COLUMN_DATAS[columnName] || columnName;
    }



    /**
     * 仅刷新tag...
     */
    const refreshTag = (arrayDatas:any)=>{
        if (isArray(arrayDatas) && arrayDatas.length > 0){
            const newTableData = {...tableData};
            const arrayNewDatas = [];
            for (let i=0;i<newTableData.data.length;i++){
                if (arrayDatas[0].id == newTableData.data[i].id){
                    newTableData.data[i].tags = arrayDatas[0].tags;
                }
                //必须要包含当前标签才允许在列表.
                if (newTableData.data[i].tags.includes(props.tagName)){
                    arrayNewDatas.push(newTableData.data[i]);
                }
            }
            newTableData.data = arrayNewDatas;
            setTableData(newTableData);
        }
    }

    /**
     * 刷新单选，多选列的option-----各种入口.
     */
    const refreshColumnSelect = ()=>{

    }

    /**
     * 刷新单个数据....
     * @param data
     */
    const refreshSingleData = async (id,extra)=>{
        let res:any;
        if (extra?.type == 'project'){
            res = await getNoteById(id);
        }else if(extra?.type == 'board'){
            res = await getBoardById(id);
            const project = await getNoteById(res.projectId,true,true);
            if (project){
                res.projectName = project.name;
                const node = findNodeWithParents(project.doc.canvas,res.id);
                res.parentNodes = node?.parents;
            }
        }
        else{
            res = await getCardById(id);
        }
        if (res){
            const newTableData = {...tableData};
            const arrayNewDatas:any = [];
            for (let i=0;i<newTableData.data.length;i++){
                if (newTableData.data[i].id == id){
                    arrayNewDatas.push(res);
                }else{
                    arrayNewDatas.push({...newTableData.data[i]});
                }
            }
            if (!arrayNewDatas.some(p=>p.id == res.id)){
                if (res.tags && res.tags.includes(props.tagName)){
                    arrayNewDatas.push(res);
                }
            }
            if (res.isDeleted == 1 || !res.tags?.includes(props.tagName)){
                const nIndex = arrayNewDatas.findIndex(p=>p.id == res.id);
                if (nIndex != -1){
                    arrayNewDatas.splice(nIndex,1);
                }
            }
            //如果是卡片了，那么要刷新这个卡片下的所有标注....---
            if (res.type == 'card' || res.type == 'pdf' || res.type == 'video' || res.type == 'audio'){
                const arrayAnnos = await getLibraryByLibraryId(res.id);
                for (let i=0;i<arrayAnnos.length;i++){
                    const nIndex = arrayNewDatas.findIndex(p=>p.id == arrayAnnos[i].id);
                    if (nIndex != -1){
                        //替换....
                        arrayNewDatas.splice(nIndex,1,arrayAnnos[i]);
                    }
                }
            }
            newTableData.data = await applyFilterTableView(arrayNewDatas);
            //更新缓存上的.
            if (mDatasMap[props.tagName]){
                mDatasMap[props.tagName] = arrayNewDatas;
            }

            setTableData(newTableData);
        }

    }

    /**
     * 搜索
     * @param szSearchKey
     */
    const doSearch = async (szSearchKey:any)=>{
        mszSearchKeyRef.current = szSearchKey;
        const newTableData = {...tableData};
        let arrayNewDatas = [];
        if (szSearchKey){
            // const arrayTmpData = mDatasMap[props.tagName] || [];
            // for (let i=0;i<arrayTmpData.length;i++){
            //     const data = arrayTmpData[i];
            //     for (let j=0;j<newTableData.columns.length;j++){
            //         const szKey = getColumnDataRef(newTableData.columns[j].id);
            //         if (data[szKey]){
            //             let szTextData = data[szKey] + '';
            //             if (szTextData.toLowerCase()?.includes(szSearchKey)){
            //                 arrayNewDatas.push(data);
            //                 break;
            //             }
            //         }
            //     }
            // }
            arrayNewDatas = await applySearchKey(szSearchKey,tableData.data,tableData.columns);
            newTableData.data = arrayNewDatas;
        }else{
            newTableData.data = mDatasMap[props.tagName] || [];
        }

        setTableData(newTableData);
    }

    /**
     * 应用搜索的关键字....
     * @param szSearchKey
     * @param arrayDatas
     * @param columns
     */
    const applySearchKey = async (szSearchKey:any,arrayDatas:any,columns:any)=>{
        if (!szSearchKey){
            return arrayDatas;
        }
        const arrayNewDatas = [];
        const arrayTmpData = mDatasMap[props.tagName] || [];
        for (let i=0;i<arrayTmpData.length;i++){
            const data = arrayTmpData[i];
            //如果是卡片，卡片的内容也要查出来.
            if (data.type == 'card' || data.type == 'journal'){
                const doc = await getCardDoc(data.id);
                const szTxt = removeHtmlTags(doc).toLowerCase();
                if (szTxt.includes(szSearchKey)){
                    arrayNewDatas.push(data);
                    break;
                }
            }
            for (let j=0;j<columns.length;j++){
                const szKey = getColumnDataRef(columns[j].id);
                if (szKey && data[szKey]){
                    let szTextData = data[szKey] + '';
                    if (szTextData.toLowerCase()?.includes(szSearchKey)){
                        arrayNewDatas.push(data);
                        break;
                    }
                }
            }
        }
        return arrayNewDatas;
    }

    /**
     * 添加新条目....
     * @param newItem
     */
    const onAddItem = (newItem)=>{
        const newTableData = {...tableData};
        const arrayNewDatas = [];
        for (let i=0;i<newTableData.data.length;i++){
            arrayNewDatas.push({...newTableData.data[i]});
        }
        if (isArray(newItem)){
            arrayNewDatas.push(...newItem)
        }else{
            arrayNewDatas.push(newItem);
        }

        newTableData.data = arrayNewDatas;

        if (mDatasMap[props.tagName]){
            mDatasMap[props.tagName].push(newItem);
        }

        //保存排序...
        const sortIds:any = {};
        for (let i=0;i<arrayNewDatas.length;i++){
            sortIds[arrayNewDatas[i].id] = i;
        }
        props.tableView.sortIds = sortIds;
        updateView(props.tableView);
        setTableData(newTableData);
    }

    /**
     * 重置选择
     */
    const onResetChecked = ()=>{
        const newRowChecked = {...rowChecked};
        const arrayKeys = Object.keys(newRowChecked);
        for (let i=0;i<arrayKeys.length;i++){
            newRowChecked[arrayKeys[i]] = false;
        }
        mRowCheckedRef.current = newRowChecked;
        setRowChecked(newRowChecked);
    }

    const onResetSearch = ()=>{
        mszSearchKeyRef.current = '';
    }

    /**
     * 清空所有选中的索引
     */
    const onClearRowCheckedIds = ()=>{
        setRowChecked({})
    }

    /**
     * 删除选择的--从库中删除
     */
    const onDeleteSelect = async ()=>{
        const newTableData = {...tableData};
        const arrayNewData = [];
        for (let i=0;i<newTableData.data.length;i++){
            const data = newTableData.data[i];
            if (rowChecked[i]){
                delete rowChecked[i];//删除这个索引...
                //从库中删除...
                data.isDeleted = 1;
                if (data.type && data.type != 'project'){
                    await updateCard(data)
                }else{
                    await updateNote(data);
                }
            }else{
                arrayNewData.push(newTableData.data[i]);
            }
        }
        newTableData.data = arrayNewData;
        setTableData(newTableData);
    }

    /**
     * 更新所有选中的数据，如果没有列，就自动加上.
     */
    const onUpdateSelectValue = (optionData,value)=>{
        const newTableData = {...tableData};
        const arrayNewData:any = [];
        const arrayDbToLibrary:any = [];
        const arrayDbToProject:any = [];
        for (let i=0;i<newTableData.data.length;i++){
            const data = newTableData.data[i];
            if (rowChecked[i]){
                if (optionData.type == 'select' || optionData.type == 'multiSelect'){
                    //selected
                    data[optionData.id] = value;
                }
                else if (optionData.type == 'text' || optionData.type == 'number' || optionData.type == 'url' || optionData.type == 'rating' || optionData.type == 'date' || optionData.type == 'checkbox'){
                    if (optionData.id == 'infoNotes' || optionData.id == 'infoUrl'){
                        //之前的2个默认的属性
                        data[optionData.id] = value;
                    }else{
                        if (!data[optionData.id]){
                            data[optionData.id] = {
                                header:optionData.name,
                                type:optionData.type
                            }
                        }
                        data[optionData.id].text = value;
                    }
                }else{

                }
                if (data.type && data.type != 'project'){
                    arrayDbToLibrary.push(data);
                }else{
                    arrayDbToProject.push(data);
                }
            }
            arrayNewData.push(data);
        }

        //保存到数据库...
        if (arrayDbToLibrary.length >0){
            batchUpdateCard(arrayDbToLibrary);
        }
        if (arrayDbToProject.length >0){
            batchUpdateProject(arrayDbToProject);
        }

        newTableData.data = arrayNewData;
        setTableData(newTableData);
    }

    /**
     * 取选择的数据
     */
    const onGetSelectItems = ()=>{
        const arrayNewData = [];
        for (let i=0;i<tableData.data.length;i++){
            const data = tableData.data[i];
            if (rowChecked[i]){
                arrayNewData.push(tableData.data[i]);
            }
        }
        return arrayNewData;
    }

    /**
     * 取全部数据
     */
    const onGetData = ()=>{
        return tableData.data;
    }

    /**
     * 当前数据的所有tag
     */
    const onGetThatAllTags = ()=>{
        const arrayTags:any = [];
        const arrayDatas = mDatasMap[props.tagName];
        if (arrayDatas){
            for (let i=0;i<arrayDatas.length;i++){
                const data = arrayDatas[i];
                if (data.tags){
                    for (let j=0;j<data.tags.length;j++){
                        if (!arrayTags.includes(data.tags[j])){
                            arrayTags.push(data.tags[j]);
                        }
                    }
                }
            }
        }

        return arrayTags;
    }

    /**
     * 计算文本区域在cell的高度
     * @param width
     * @param text
     */
    const calcTextareaInCellHeight = (width:any,text:any)=>{
        const textArea = document.createElement('textarea');
        textArea.className = 'tableview-textarea default-font-size';
        textArea.value = text;
        textArea.style.zIndex = '999999';
        textArea.style.left = '0';
        textArea.style.top = '0';
        textArea.style.width = width + 'px';
        document.body.append(textArea);
        let nHeight = textArea.scrollHeight;
        textArea.style.height = nHeight + 'px';
        document.body.removeChild(textArea);
        if (nHeight > 135){
            nHeight = 135;
        }
        return nHeight;
    }

    /**
     * 更新条目----
     * @param row
     */
    const updateItem = (row)=>{
        if (row.original.type == 'project') {
            return updateProject(row.original);
        }else if (row.original.type == 'board'){
            return updateBoard(row.original);
        }
        else {
            return updateCard(row.original);
        }
    }

    /**
     * 如果有过滤条件，每动一下就要刷新
     */
    const refreshFilterData = async ()=>{
        if (mTableviewDataRef.current.conditions && mTableviewDataRef.current.conditions.length > 0){
            const newTableData = {...mTableviewDataRef.current};
            // const arrayColumns:any =[];
            // for (let i=0;i<newTableData.columns.length;i++){
            //     arrayColumns.push({...newTableData.columns[i]})
            // }
            // newTableData.columns = arrayColumns;
            //先过滤搜索的，再应用过滤的filter----
            let arrayData = await applyFilterTableView(newTableData.data);
            newTableData.data = arrayData;
            setTableData(newTableData);
        }
    }


    /**
     * 过滤视图的数据...
     */
    const applyFilterTableView = async (arrayDatas:any)=>{
        if (!props.tableView.conditions) {
            if (!props.tableView.sortColumn){
                props.tableView.sortColumn = {id:'createTime',sort:'sortAZ'};
            }
            if (props.tableView.sortColumn){
                sortByColumnDatas({id:props.tableView.sortColumn.id},props.tableView.sortColumn.sort,arrayDatas);
            }
            return arrayDatas;
        }
        const arrayNewData = [];
        const arrayConditions = props.tableView.conditions;
        for (let k=0;k<arrayDatas.length;k++){
            const data = arrayDatas[k];
            let bOk = true;
            for (let i=0;i<arrayConditions.length;i++){
                const condition = arrayConditions[i];
                let propertyData = data[condition.columnId];

                let propertyValue:any = propertyData;
                if (isObject(propertyData)){
                    //如果是文本
                    if ((propertyData.type == 'select' || propertyData.type == 'multiSelect' || isArray(propertyData))){
                        propertyValue = propertyData;
                    }else{
                        propertyValue = (propertyData.text || '') + '';//变成字符串。。。。。
                    }
                }
                //如果条件没有值，并且不是empty,notempty 忽略这个条件
                if (!condition.value && (condition?.operator != 'isEmpty' || condition?.operator != 'isNotEmpty')){
                    if (condition.operator == 'isEmpty'){
                        if (isArray(propertyValue)){
                            if (propertyValue.length > 0){
                                //有值
                                bOk = false;
                                break;
                            }
                        }else {
                            if (propertyValue) {
                                //有值
                                bOk = false;
                                break;
                            }
                        }
                    }else if (condition.operator == 'isNotEmpty'){
                        if (!propertyValue || (isArray(propertyValue) && propertyValue.length == 0)){
                            bOk = false;
                            break;
                        }
                    }
                    continue;
                }


                if (propertyValue || isArray(propertyData)){
                    if (condition.operator == 'isEmpty'){
                        if (propertyData){
                            bOk = false;
                            break;
                        }
                    }

                    if (condition.value){
                        if (propertyData?.type == 'number' || propertyData?.type == 'rating'){
                            //region 数字类型
                            const fNumberValue = getSafeFloat(propertyValue);
                            const fConditionValue = getSafeFloat(condition.value);
                            if (condition.operator == '='){
                                if (fConditionValue != fNumberValue){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == '≠'){
                                if (fConditionValue == fNumberValue){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == '>'){
                                if (fNumberValue <= fConditionValue){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == '≥'){
                                if (fNumberValue < fConditionValue){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == '<'){
                                if (fNumberValue >= fConditionValue){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == '≤'){
                                if (fConditionValue < fNumberValue){
                                    bOk = false;
                                    break;
                                }
                            }
                            //endregion
                        }else if (condition.type == 'date' || propertyData?.type == 'date'){
                            //region 日期
                            let nPropertyDate:any = formatDate(propertyData?.text || propertyData,'yyyyMMdd');
                            nPropertyDate = parseInt(nPropertyDate);
                            let nConditionDate:any = formatDate(condition.value,'yyyyMMdd');
                            nConditionDate = parseInt(nConditionDate);

                            if (condition.operator == 'equals'){
                                if (nPropertyDate != nConditionDate){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'before'){
                                if (nPropertyDate >= nConditionDate){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'after'){
                                if (nPropertyDate <= nConditionDate){
                                    bOk = false;
                                    break;
                                }
                            }
                            //endregion
                        }else if (propertyData?.type == 'checkbox'){
                            //region 只有一个操作符 is
                            if (condition.value == 'checked'){
                                if (propertyData?.text != true){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.value == 'unchecked'){
                                if (propertyData?.text){
                                    bOk = false;
                                    break;
                                }
                            }
                            //endregion
                        }else if (isArray(propertyData) || propertyData?.type == 'select' || propertyData?.type == 'multiSelect'){
                            //region 多选----
                            let arrayConditionValue = condition.value;
                            const arrayStrData:any = [];
                            propertyData.forEach(ppp=>{
                                arrayStrData.push(ppp.text || ppp);
                            })
                            if (condition.operator == 'is'){
                                if (JSON.stringify(arrayConditionValue) != JSON.stringify(arrayStrData)){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'isNot'){
                                if (JSON.stringify(arrayConditionValue) == JSON.stringify(arrayStrData)){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'contains'){
                                if (!containsAllEvery(arrayStrData,arrayConditionValue)){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'doesNotContain'){
                                if (containsAllEvery(arrayStrData,arrayConditionValue)){
                                    bOk = false;
                                    break;
                                }
                            }
                            //endregion
                        }else if (condition?.type == 'tags' || propertyData?.type == 'tags'){
                            propertyValue = propertyValue?.toLowerCase();
                            let szConditionValue = condition.value.toLowerCase();
                            if (condition.operator == 'is'){
                                if (szConditionValue != propertyValue){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'isNot'){
                                if (szConditionValue == propertyValue){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'contains'){
                                if (!propertyValue.includes(szConditionValue)){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'doesNotContain'){
                                if (propertyValue.includes(szConditionValue)){
                                    bOk = false;
                                    break;
                                }
                            }
                        }else if (condition?.type == 'type' || propertyData?.type == 'type'){
                            //region 多选----
                            let arrayConditionValue = condition.value;
                            const arrayStrData:any = [propertyData];//这个是类型...
                            if (condition.operator == 'is'){
                                if (JSON.stringify(arrayConditionValue) != JSON.stringify(arrayStrData)){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'isNot'){
                                if (JSON.stringify(arrayConditionValue) == JSON.stringify(arrayStrData)){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'contains'){
                                if (!containsAllEvery(arrayStrData,arrayConditionValue)){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'doesNotContain'){
                                if (containsAllEvery(arrayStrData,arrayConditionValue)){
                                    bOk = false;
                                    break;
                                }
                            }
                            //endregion
                        }
                        else{
                            //region 字符串类型
                            propertyValue = propertyValue?.toLowerCase();
                            let szConditionValue = condition.value.toLowerCase();
                            if (condition.operator == 'is'){
                                if (szConditionValue != propertyValue){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'isNot'){
                                if (szConditionValue == propertyValue){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'contains'){
                                if (!propertyValue.includes(szConditionValue)){
                                    bOk = false;
                                    break;
                                }
                            }else if (condition.operator == 'doesNotContain'){
                                if (propertyValue.includes(szConditionValue)){
                                    bOk = false;
                                    break;
                                }
                            }
                            //endregion
                        }
                    }else{
                        //region 没有条件值

                        //endregion
                    }
                } else{
                    //region 没有数据值
                    if (condition.operator == 'isNotEmpty'){
                        bOk = false;
                        break;
                    }else if (condition.operator == 'isEmpty'){

                    }else{
                        if (condition?.type == 'number' || condition?.type == 'rating'){
                            if (condition.operator == '≠'){

                            }else{
                                bOk = false;
                                break;
                            }
                        }else if (condition?.type == 'date'){
                            bOk = false;
                            break;
                        }else if (condition?.type == 'checkbox'){
                            if (condition.value == 'checked'){
                                bOk = false;
                                break;
                            }
                        }else{
                            if (condition?.operator == 'isNot' || condition.operator == 'doesNotContain'){

                            }else{
                                bOk = false;
                                break;
                            }
                        }
                    }
                    //endregion
                }
            }
            if (bOk){
                arrayNewData.push(data);
            }
        }

        if (props.tableView.sortColumn){
            sortByColumnDatas({id:props.tableView.sortColumn.id},props.tableView.sortColumn.sort,arrayNewData);
        }

        return arrayNewData;
    }

    /**
     * 这里新增或者删除列的时候要处理一遍数据，把新增加的列属性加到全部的数据上。
     * 不然导出项目的时候有些没数据的列就不会显示在上面.......
     */
    const handleAddDataColumn = (tableData:any)=>{
        if (!global.g_tableviewUpdateProperty){
            return;
        }
        global.g_tableviewUpdateProperty = false;
        const arrayLibrarys:any = [];
        const arrayProjects:any = [];
        const arrayBoards:any = [];
        for (let i=0;i<tableData.data.length;i++){
            const data = tableData.data[i];
            //所有的列.
            for (let j=0;j<tableData.columns.length;j++){
                const column = tableData.columns[j];
                if (column.groupName == 'custom'){
                    if (!data[column.id]){
                        if (column.type == 'select' || column.type == 'multiSelect'){
                            data[column.id] = [];//单选，多选..
                        }else{
                            data[column.id] = {
                                type:column.type,
                            }
                        }
                        if (data.type == 'board'){
                            arrayBoards.push(data);
                        }
                        else if (data.type && data.type != 'project'){
                            arrayLibrarys.push(data);
                        }else{
                            arrayProjects.push(data);
                        }
                    }
                }
            }
        }
        //批量更新.
        if (arrayLibrarys.length > 0){
            batchUpdateCard(arrayLibrarys);
        }
        if (arrayProjects.length >0){
            batchUpdateProject(arrayProjects)
        }
        if (arrayBoards.length > 0){
            batchUpdateBoard(arrayBoards);
        }
    }

    /**
     * 取deeplink图片
     * @param item
     */
    const getDeeplinkImage = (item)=>{
        if (isDeepLink(item.link)){
            const deeplink = decodeDeeplink(item.link);
            return getImageNameFromdeepLinkType(deeplink.childType);
        }
        return 'deeplink_link.svg';
    }
    /**
     * 刷新数据
     */
    const refreshData = async ()=>{

        const newTableData = {...props.tableView};
        if (newTableData.data.length == 0){
            setIsLoading(true);
        }

        const arrayNewColumns:any = [];
        let nWidth = 0;
        const newColumnSizing:any = {};
        let i= -1;
        for (;i<newTableData.columns.length;i++){
            let column:any = null;
            if (i== -1){
                column = {
                    id:'checked',
                    width:COLUMN_WIDTH_CHECKED,
                }

                newColumnSizing[column.id] = column.width;
            }else{
                column = {...newTableData.columns[i]};
                //重新读取....--如果数据库没有的话忽略这个属性.
                const property = await getPropertyById(column.id);
                if (!property)continue;

                newColumnSizing[column.id] = column.width || 280;
                column.enableResizing = true;
                column.accessorKey = column.id;
                column.name = column.header = property.groupName == 'default'?t(property.name):property.name;
                column.sort = i+'';
                column.groupName = property.groupName;
                column.type = property.type;

                if (column.items){
                    column.items = property?.items;
                    column.items?.forEach(p=>{
                        p.isEditable = false;
                        p.isHovered = false;
                    })
                }
            }

            column.cell =  ({ cell, row }) => {
                const [inputValue,setInputValue] = useState({infoNotes:row.original.infoNotes,isInfoNotesEditor:false,infoUrl:row.original.infoUrl,isLinkEditor:false,name:row.original.name,isNameEditor:row.original.isNew});
                //自定义的属性，输入----
                const [customInputInfo,setCustomInputInfo] = useState<any>({[cell.column.id]: {...row.original[cell.column.id] || {}}});
                const inputNotesRef = useRef(null);
                const inputUrlRef = useRef(null);
                const inputNameRef = useRef(null);
                const [arraySelectOptions,setArraySelectOptions] = useState<any>(cell.column.columnDef.items);
                const [isInputFocus,setIsInputFocus] = useState(false);
                const [arraySelectInfo,setArraySelectInfo] = useState<any>(isArray(row.original[cell.column.id])?row.original[cell.column.id] : []);//多选或单选使用的
                const mArraySelectInfo = useRef(null);
                const [isEditable,setIsEditable] = useState(false);
                const [isDateEditable,setIsDateEditable] = useState(false);
                const inputTextRef = useRef(null);
                const [customInputTextInfo,setCustomInputTextInfo] = useState(row.original[cell.column.id]);
                const [isSelectOpen,setIsSelectOpen] = useState(true);
                const [isSelectMoreOpen,setIsSelectMoreOpen] = useState<any>({});

                let rowIndex = row.index;

                if (Date.now() - row.original.createTime > 1000){
                    delete row.original.isNew;
                }

                useEffect(() => {
                    //从属性里面重新读取
                    window.closeEditable = ()=>{
                        // setIsEditable(false);
                        setIsDateEditable(false);
                    }
                });

                useEffect(() => {
                    window.autoRowTextFocus = (szId)=>{
                        setTimeout(() => {
                            const textArea = document.getElementById(`tableview-textarea-name-${szId}`);
                            if (textArea){
                                textArea.focus();
                            }
                        }, 200)
                    }
                }, [inputValue.isNameEditor]);

                // useEffect(() => {
                //     console.log(isEditable)
                // }, [isEditable]);

                useEffect(() => {
                    mArraySelectInfo.current = arraySelectInfo;
                }, [arraySelectInfo]);

                const getName = ()=>{
                    let szName = row.original.name;

                    if (row.original.type == 'pdfAnno' || row.original.type == 'cardAnno'){
                        szName = row.original.name + '->'+(row.original.comment || row.original.text || t('Area highlight'));
                    }else if (row.original.type == 'videoAnno' || row.original.type == 'audioAnno'){
                        let szTime = formatDateHms(row.original.time)
                        szName = row.original.name + `(${szTime})`+ '->'+(row.original.title || row.original.content);
                    }else if (row.original.type == 'board'){
                        szName = row.original.projectName + '/';
                        if (row.original.parentNodes){
                            szName += row.original.parentNodes.map(p=>{
                                return p.title + '/';
                            }).join('');
                        }
                        szName += row.original.name;
                    }

                    if (!szName){
                        if (row.original.type == 'card'){
                            szName = getCardTitle(row.original);
                        }else{
                            szName = t('Untitled');
                        }
                    }
                    return szName;
                }
                if (cell.column.id == 'checked'){
                    //region checked
                    return <div className={'flex-row-vertical-center cursor-pointer tableview-column-style'}
                                style={{width: `${cell.column.getSize() - 20}px`, height: '100%'}}
                                onClick={async (e) => {

                                }}>
                        <img className={'img-18 cursor-pointer'}
                             style={{opacity: mRowCheckedRef.current[rowIndex] ? 1 : 1/*visibility:(rowChecked[rowIndex] || mapIsRowHovered[rowIndex])?'visible':'hidden'*/}}
                             src={getImagePathWithThemeSvg(`${mRowCheckedRef.current[rowIndex] ? 'table_view_checked' : 'table_view_uncheck'}`)}
                             onClick={(e) => {
                                 const newRowCheck = {...mRowCheckedRef.current};
                                 newRowCheck[rowIndex] = (!(newRowCheck[rowIndex] || false));
                                 if (e.shiftKey) {
                                     //选中当前和前面
                                     const arrayKeys = Object.keys(newRowCheck);
                                     let nMinIndex: any = 0;
                                     for (let i = arrayKeys.length - 1; i >= 0; i--) {
                                         if (newRowCheck[arrayKeys[i]] && arrayKeys[i] < rowIndex) {
                                             nMinIndex = arrayKeys[i];
                                             break;
                                         }
                                     }
                                     for (let i = nMinIndex; i < rowIndex; i++) {
                                         newRowCheck[i] = true;
                                     }
                                 }
                                 mRowCheckedRef.current = newRowCheck;
                                 setRowChecked(newRowCheck);
                                 //如果有选择的，就显示选项
                                 props.onRefreshCheck(newRowCheck)
                             }}
                        />
                    </div>
                    //endregion
                } else if (cell.column.id == 'name') {
                    //region name
                    return <div className={'flex-row-vertical-center cursor-pointer tableview-column-style'}
                                style={{width: `${cell.column.getSize() - 20}px`, height: '100%',padding:'0px'}}
                                onClick={async (e) => {
                                    //打开行，打开条目，打开这一行，点击这一行，点击行
                                    if (row.original.type == 'row' && !isDeepLink(row.original.link)) return;
                                    let item = row.original;
                                    if (item.type == 'row') {
                                        if (isDeepLink(item.link)) {
                                            const deeplink = decodeDeeplink(item.link);
                                            if (deeplink.type == 'project') {
                                                item = await getNoteById(deeplink.id);
                                            } else {
                                                item = await getCardById(deeplink.id);
                                            }
                                        } else {
                                            openUrlOrLocalPath(item.link);
                                            return;
                                        }
                                    }


                                    if (e.metaKey || e.ctrlKey) {
                                        global.g_isCtrlPressed = true;
                                        setTimeout(() => {
                                            global.g_isCtrlPressed = false;
                                        }, 2000)
                                    }
                                    if (item.type == 'project') {
                                        window.navigate(getDrawPath(), {
                                            searchKey: '',
                                            linkInfo: {id: item.id, pageId: '', elementId: ''}
                            });
                            postMessage(EVENT_RESET_NO_SELECTED);
                        }else if (item.type == 'board'){
                            window.navigate(getDrawPath(), {
                                searchKey: '',
                                linkInfo: {id: row.original.projectId, pageId: row.original.id, elementId: ''}
                            });
                            postMessage(EVENT_RESET_NO_SELECTED);
                        }
                        else{
                            //库中的数据.
                            postMessage(EVENT_OPEN_LIBRARY_ITEM,{...item,openInDialogAnno:true,deeplink:createCopyLinkByLibraryItem(item,false)})
                        }
                    }}>
                        {
                            (row.original.type != 'row') ?
                            <>
                                <img className={'img-16'}
                                     src={getImagePathWithTheme(getImageNameFromdeepLinkType(row.original.type))}/>
                                <span className={'ml-6 span-single-line'}>{getName()}</span>
                            </> :
                                <>
                                    {
                                        row.original.link &&
                                        <img className={'img-16'}
                                             src={getImagePathWithTheme(getDeeplinkImage(row.original))} onClick={(e)=>{
                                                 if (!isDeepLink(row.original.link)){
                                                     openUrlOrLocalPath(row.original.link);
                                                 }
                                        }}/>
                                    }
                                    <div className={'flex-row-vertical-center td-div-relative tableview-column-style cursor-pointer div-type-row'}
                                                style={{width: `${cell.column.getSize() - 20}px`,height:'100%'}} onClick={(e) => {
                                                    if (row.original.type == 'row' && isDeepLink(row.original.link))return;

                                    const newInputValue = {...inputValue};
                                    newInputValue.isNameEditor = true;
                                    setInputValue(newInputValue);
                                    setTimeout(() => {
                                        inputNameRef.current?.focus();
                                    }, 200)
                                }}>
                                    {/*<img className={'img-16'} src={getImagePathWithTheme(getImageNameFromdeepLinkType(row.original.type))}/>*/}
                                    {
                                        inputValue.isNameEditor ?
                                            <textarea ref={inputNameRef} className={'tableview-textarea default-font-size'}
                                                      id={`tableview-textarea-name-${row.original.id}`}
                                                      style={{height: `${calcTextareaInCellHeight(cell.column.getSize(), inputValue.name)}px`}}
                                                      value={inputValue.name} onInput={(e) => {
                                                const szInput = e.currentTarget.value;
                                                row.original.name = szInput;
                                                const newInputValue = {...inputValue};
                                                newInputValue.name = szInput;
                                                setInputValue(newInputValue);
                                            }} onBlur={(e) => {
                                                const szInput = e.currentTarget.value;
                                                const newInputValue = {...inputValue};
                                                newInputValue.isNameEditor = false;
                                                setInputValue(newInputValue);
                                                //更新到当前
                                                row.original.name = szInput;
                                                updateItem(row);

                                                refreshFilterData();
                                            }} onFocus={(e)=>{
                                                e.currentTarget.setSelectionRange(e.currentTarget.value.length,e.currentTarget.value.length)
                                            }} onKeyDown={(e)=>{
                                                if (e.key == KEYS.ENTER){//哪里会处理这个enter ?????????????????????????????????????????? 找不到...
                                                    if (e.ctrlKey || e.metaKey){
                                                        console.log('e.shiftkey*****')
                                                        let szTxt = e.currentTarget.value;

                                                        const newInputValue = {...inputValue};
                                                        newInputValue.name = szTxt + '\r\n';
                                                        setInputValue(newInputValue);

                                                        e.stopPropagation();
                                                    }else if (e.shiftKey){
                                                        e.stopPropagation();
                                                    }
                                                    else{
                                                        e.currentTarget.blur();
                                                    }
                                                }
                                            }}/>:
                                            <span className={'cursor-pointer span-single-line'} style={{lineHeight:'18px',marginLeft:(row.original.link)?'0px':'-8px'}} >{inputValue.name || ''}</span>
                                    }
                                </div>
                                </>
                        }
                    </div>
                    //endregion
                } else if (cell.column.id == 'createTime') {
                    const date = new Date(row.original.createTime);
                    return <div className={'flex-row-vertical-center  tableview-column-style'} style={{width:`${cell.column.getSize() - 20}px`}}>
                        {/*<img className={'img-16'} src={getImagePathWithTheme(getImageNameFromdeepLinkType(row.original.type))}/>*/}
                        <span className={'span-single-line'}>{`${MAP_MONTH[date.getMonth()+1]} ${date.getDate()}, ${date.getFullYear()} ${formatDate(row.original.createTime,'hh:mm')}`}</span>
                    </div>
                }else if (cell.column.id == 'updateTime'){
                    const date = new Date(row.original.updateTime);
                    return <div className={'flex-row-vertical-center  tableview-column-style'} style={{width:`${cell.column.getSize() - 20}px`}}>
                        {/*<img className={'img-16'} src={getImagePathWithTheme(getImageNameFromdeepLinkType(row.original.type))}/>*/}
                        <span className={'span-single-line'}>{`${MAP_MONTH[date.getMonth()+1]} ${date.getDate()}, ${date.getFullYear()} ${formatDate(row.original.updateTime,'hh:mm')}`}</span>
                    </div>
                }else if (cell.column.id == 'infoNotes'){
                    //region notes
                    return <div className={'flex-row-vertical-center td-div-relative tableview-column-style cursor-pointer'}
                                style={{width: `${cell.column.getSize() - 20}px`,height:'100%'}} onClick={(e) => {
                        const newInputValue = {...inputValue};
                        newInputValue.isInfoNotesEditor = true;
                        setInputValue(newInputValue);
                        setTimeout(() => {
                            inputNotesRef.current?.focus();
                        }, 100)
                    }}>
                        {/*<img className={'img-16'} src={getImagePathWithTheme(getImageNameFromdeepLinkType(row.original.type))}/>*/}
                        {
                            inputValue.isInfoNotesEditor ?
                                <textarea ref={inputNotesRef} className={'tableview-textarea default-font-size'}
                                          style={{height: `${calcTextareaInCellHeight(cell.column.getSize(), inputValue.infoNotes)}px`}}
                                          value={inputValue.infoNotes} onInput={(e) => {
                                    const szInput = e.currentTarget.value;
                                    row.original.infoNotes = szInput;
                                    const newInputValue = {...inputValue};
                                    newInputValue.infoNotes = szInput;
                                    setInputValue(newInputValue);
                                }} onBlur={(e) => {
                                    const szInput = e.currentTarget.value;
                                    const newInputValue = {...inputValue};
                                    newInputValue.isInfoNotesEditor = false;
                                    setInputValue(newInputValue);
                                    //更新到当前
                                    row.original.infoNotes = szInput;
                                    updateItem(row);

                                    refreshFilterData();
                                }} onFocus={(e)=>{
                                    e.currentTarget.setSelectionRange(e.currentTarget.value.length,e.currentTarget.value.length)
                                }} onKeyDown={(e)=>{
                                    if (e.key == KEYS.ENTER){//哪里会处理这个enter ?????????????????????????????????????????? 找不到...
                                        if (e.ctrlKey || e.metaKey){
                                            console.log('e.shiftkey*****')
                                            let szTxt = e.currentTarget.value;

                                            const newInputValue = {...inputValue};
                                            newInputValue.infoNotes = szTxt + '\r\n';
                                            setInputValue(newInputValue);

                                            e.stopPropagation();
                                        }else if (e.shiftKey){
                                            e.stopPropagation();
                                        }
                                        else{
                                            e.currentTarget.blur();
                                        }
                                    }
                                }}/>:
                                <span className={'cursor-pointer span-single-line'} style={{}} >{inputValue.infoNotes}</span>
                        }

                    </div>
                    //endregion
                } else if (cell.column.id == 'infoUrl') {
                    //region link
                    return <div className={'flex-row-vertical-center tableview-column-style cursor-pointer'} onClick={(e) => {
                        const newInputValue = {...inputValue};
                        newInputValue.isLinkEditor = true;
                        setInputValue(newInputValue);
                        setTimeout(() => {
                            inputUrlRef.current?.focus();
                        }, 100)
                    }}
                                style={{
                                    width: `${cell.column.getSize()}px`,
                                    height: '100%',
                                    position: 'relative'
                                }}>
                        {
                            inputValue.isLinkEditor ?
                                <textarea ref={inputUrlRef} className={'tableview-textarea default-font-size'}
                                          style={{height: `${calcTextareaInCellHeight(cell.column.getSize(), inputValue.infoUrl)}px`}}
                                          value={inputValue.infoUrl} onMouseDown={(e) => {
                                    e.stopPropagation();
                                }} onInput={(e) => {
                                    const szInput = e.currentTarget.value;
                                    row.original.infoUrl = szInput;
                                    const newInputValue = {...inputValue};
                                    newInputValue.infoUrl = szInput;
                                    setInputValue(newInputValue);
                                }} onBlur={(e) => {
                                    const szInput = e.currentTarget.value;

                                    const newInputValue = {...inputValue};
                                    newInputValue.isLinkEditor = false;
                                    setInputValue(newInputValue);
                                    //更新到当前
                                    row.original.infoUrl = szInput;
                                    updateItem(row);

                                    refreshFilterData();
                                }} onFocus={(e)=>{
                                    e.currentTarget.setSelectionRange(e.currentTarget.value.length,e.currentTarget.value.length)
                                }} onKeyDown={(e)=>{
                                    if (e.key == KEYS.ENTER) {//哪里会处理这个enter ?????????????????????????????????????????? 找不到...
                                        e.currentTarget.blur();
                                    }
                                }}/> :<>
                                    {
                                        isDeepLink(inputValue.infoUrl) ? <CustomDeeplink url={inputValue.infoUrl}/> :
                                            <span className={'cursor-pointer span-single-line'}
                                                  style={{color: 'var(--color-link)'}} onClick={(e) => {
                                                // e.stopPropagation();
                                                // let szUrl = inputValue.infoUrl;
                                                // if (!szUrl.startsWith('http')) {
                                                //     szUrl = 'https://' + inputValue.infoUrl;
                                                // }
                                                // //打开链接
                                                // ipcInvoke('open-url-withwhen', szUrl).then(res => {
                                                //     if (res == 'error') {
                                                //         message.error(t("Open error"));
                                                //     }
                                                // })
                                            }}>{inputValue.infoUrl}</span>
                                    }
                                </>

                        }

                        <Tooltip arrow={false} title={t("Open in browser")}>
                            <img className={'img-24 cursor-pointer ml-4 operator-icon'} style={{
                                position: 'absolute',
                                right: '6px',
                                display: inputValue.infoUrl ? 'inherit' : 'none'
                            }}
                                 src={getImagePathWithThemeSvg('tableview_item_open')} onClick={async (e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                let szUrl = inputValue.infoUrl;
                                if (isDeepLink(szUrl)) {
                                    const deeplink = decodeDeeplink(szUrl);
                                    if (deeplink.type == 'library' || deeplink.type == 'highlight') {
                                        postMessage(EVENT_OPEN_LIBRARY_ITEM, {
                                            id: deeplink.id,
                                            from: FROM_LIBRARY,
                                            deeplink: deeplink,
                                            selectedId: deeplink.childId,
                                            inSlider: (e.metaKey || e.ctrlKey)
                                        })
                                        if (deeplink.childType == 'card' || deeplink.childType == 'video' || deeplink.childType == 'pdf' || deeplink.childType == 'highlight') {
                                            if (window.location.href.includes('/card') || window.location.href.includes('/journal')) {
                                                const hasFirst = localStorage.getItem(KEY_IS_FIRST_OPEN_LIBRARY_REF) || 'true';
                                                if (hasFirst == 'true') {
                                                    message.info(t("HoldCtrlDownAndCtrl").replace('Cmd',(isMac()?'Cmd':'Ctrl')));
                                                    localStorage.setItem(KEY_IS_FIRST_OPEN_LIBRARY_REF,'false')
                                                }
                                            }
                                        }
                                    } else {
                                        const linkInfo = await deepLinkToLinkInfo(deeplink);
                                        postMessage(EVENT_SHOW_DIALOG_DRAWINDEX, {linkInfo,inSlider:(e.metaKey || e.ctrlKey)});
                                    }
                                }else{
                                    if (!szUrl.startsWith('http') && !isSupportLink(szUrl)) {
                                        szUrl = 'https://' + inputValue.infoUrl;
                                    }

                                    //打开链接
                                    ipcInvoke('open-url-withwhen', szUrl).then(res => {
                                        if (res == 'error') {
                                            message.error(t("Open error"));
                                        }
                                    })
                                }
                        }}/>
                        </Tooltip>

                    </div>
                    //endregion
                } else if (cell.column.id == 'project') {
                    //region project
                    return <div className={'flex-row-vertical-center span-single-line tableview-column-style'}
                                style={{width: `${cell.column.getSize() - 20}px`}}>
                        {
                            row.original.arrayInProjects?.map((item, index) => {
                                return (
                                    <div onClick={() => {
                                        //转到项目
                                        window.navigate(getDrawPath(), {
                                            searchKey: '',
                                            linkInfo: {id: item.id, pageId: item.boardId, elementId: item.elementId}
                                        });
                                        postMessage(EVENT_RESET_NO_SELECTED);
                                    }}>
                                        <span
                                            className={'ml-0 hovered-font-blue'}>{item.name || t('Untitled')}</span>
                                        {
                                            index != row.original.arrayInProjects.length -1 &&
                                            <span style={{marginRight:'4px'}}>,</span>
                                        }
                                    </div>
                                )
                            })
                        }

                    </div>
                    //endregion
                }else if (cell.column.id == 'tags'){
                    //region tags
                    const getTagBackgroundColor = (szTagName:any)=>{
                        const tag = mArrayTags.current?.find(p=>p.name == szTagName);
                        let szBackgroundColor = tag?.backgroundColor || DEFAULT_TAG_BACKGROUND_COLOR;
                        if (isDarkMode()){
                            if (szBackgroundColor == DEFAULT_TAG_BACKGROUND_COLOR){
                                szBackgroundColor = DEFAULT_DARK_TAG_BACKGROUND_COLOR;
                            }
                        }
                        return szBackgroundColor;
                    }

                    const getTagColor = (szTagName:any)=>{
                        const tag = mArrayTags.current?.find(p=>p.name == szTagName);
                        let szTextColor = MAP_GROUP_BACKGROUND_COLOR[tag?.backgroundColor] || '#000000';
                        if (szTextColor == '#000000' && isDarkMode()){
                            szTextColor = '#FFFFFF';
                        }
                        // if (tag?.isSelected){
                        //     szTextColor = '#FFFFFF';
                        // }
                        return szTextColor;
                    }
                    return <div className={'flex-row-vertical-center cursor-pointer tableview-column-style'}
                                style={{width: `${cell.column.getSize() - 20}px`,gap:'0px 8px',height:'100%',overflow:'hidden'}} onClick={(e)=>{
                                    //打开tag...
                        window.showManageTags([row.original]);
                    }}>
                        {
                            row.original.tags?.map((item,index)=> {
                                return <span style={{color:getTagColor(item),background:getTagBackgroundColor(item),borderRadius:'4px',padding:'2px 6px',textWrap:'nowrap'}} className={'ml-0'}>{item}</span>
                            })
                        }
                    </div>
                    //endregion
                }else if (cell.column.id == 'type'){
                    //region type
                    const getTypeName = ()=>{
                        if (row.original.type == 'project'){
                            return t('Project');
                        }else if (row.original.type  == 'board'){
                            return t('Board')
                        }

                        let szType = row.original.type;
                        if (row.original.type == 'bilibili' || row.original.type == 'baidu' || row.original.type == 'youtube'){
                            szType =  'liveVideo';
                        }
                        const libraryType = GET_ARRAY_LIBRARY_TYPES().find(p=>p.value == szType);
                        if (libraryType){
                            return libraryType.label;
                        }
                        return '';
                    }
                    return <div className={'flex-row-vertical-center tableview-column-style'}
                                style={{width: `${cell.column.getSize() - 20}px`}}>
                        <img className={'img-16'} src={getImagePathWithTheme(getImageNameFromdeepLinkType(row.original.type))}/>
                        <span className={'ml-6 span-single-line'}>{getTypeName()}</span>
                    </div>
                    //endregion
                }else {
                    //这里是自定义的属性----
                    if (cell.column.columnDef.type == 'text') {
                        //region text
                        return <div className={'flex-row-vertical-center td-div-relative tableview-column-style cursor-pointer'}
                                    style={{width: `${cell.column.getSize() - 20}px`, height: '100%'}} onClick={(e) => {
                            const newCustomInputInfo: any = {...customInputInfo};
                            //先将全部的置为false
                            const arrayKeys = Object.keys(newCustomInputInfo);
                            for (let i = 0; i < arrayKeys.length; i++) {
                                newCustomInputInfo[arrayKeys[i]].isEditable = false;
                            }
                            const newInfo = {...newCustomInputInfo[cell.column.id] || {}};
                            newInfo.isEditable = true;
                            newCustomInputInfo[cell.column.id] = newInfo;
                            setCustomInputInfo(newCustomInputInfo);
                        }}>
                            {
                                customInputInfo[cell.column.id]?.isEditable ?
                                    <textarea autoFocus={true} className={'default-font-size tableview-textarea'}
                                              style={{height: `${calcTextareaInCellHeight(cell.column.getSize(), customInputInfo[cell.column.id]?.text || '')}px`}}
                                              value={customInputInfo[cell.column.id]?.text || ''}
                                              onChange={(e) => {
                                                  const newCustomInputInfo: any = {...customInputInfo};
                                                  const newInfo = {...newCustomInputInfo[cell.column.id] || {}};
                                                  newInfo.height = e.currentTarget.scrollHeight;
                                                  newInfo.text = e.currentTarget.value;
                                                  newCustomInputInfo[cell.column.id] = newInfo;
                                                  setCustomInputInfo(newCustomInputInfo);
                                              }} onBlur={(e) => {
                                        const newCustomInputInfo: any = {...customInputInfo};
                                        const newInfo = {...newCustomInputInfo[cell.column.id] || {}};
                                        newInfo.text = e.currentTarget.value;
                                        newInfo.isEditable = false;
                                        newInfo.type = cell.column.columnDef.type;
                                        newInfo.header = cell.column.columnDef.header;
                                        newCustomInputInfo[cell.column.id] = newInfo;
                                        setCustomInputInfo(newCustomInputInfo);
                                        //更新到库--增加这个属性...
                                        row.original[cell.column.id] = newInfo;
                                        //保存到库...
                                        updateItem(row);
                                        refreshFilterData()

                                    }} onFocus={(e)=>{
                                        e.currentTarget.setSelectionRange(e.currentTarget.value.length,e.currentTarget.value.length)
                                    }} onKeyDown={(e)=>{
                                        if (e.key == KEYS.ENTER){
                                            if (e.ctrlKey || e.metaKey){
                                                let szTxt = e.currentTarget.value;

                                                const newCustomInputInfo: any = {...customInputInfo};
                                                const newInfo = {...newCustomInputInfo[cell.column.id] || {}};
                                                newInfo.text = szTxt + '\r\n';
                                                newCustomInputInfo[cell.column.id] = newInfo;
                                                setCustomInputInfo(newCustomInputInfo);
                                                e.stopPropagation();
                                            }else if (e.shiftKey){
                                                e.stopPropagation();
                                            }
                                            else{
                                                e.currentTarget.blur();
                                            }
                                        }
                                    }}/> : <span
                                        className={'ml-4 span-single-line'}>{row.original[cell.column.id]?.text || ''}</span>
                            }
                        </div>
                        //endregion
                    } else if (cell.column.columnDef.type == 'select' || cell.column.columnDef.type == 'multiSelect') {
                        //region select-multiselect
                        //是多选吗？
                        const isMultipSelect = () => {
                            return cell.column.columnDef.type == 'multiSelect'
                        }
                        const tagRender: any = useCallback((props) => {
                            const ttttaaaagggggg = mArraySelectInfo.current?.find(p => p.text == props.label);
                            return (
                                <Tag
                                    closable={props.closable}
                                    // closeIcon={<img className={'img-12 mt-6'} style={{backgroundColor:'red'}} src={getImagePathWithThemeSvg("tag_delete")}/>}
                                    onClose={(e) => {
                                        const arrayNewSelect = [...row.original[cell.column.id]];
                                        const nIndex = arrayNewSelect.findIndex(p => p.text == props.label);
                                        arrayNewSelect.splice(nIndex, 1);
                                        setArraySelectInfo(arrayNewSelect);

                                        row.original[cell.column.id] = arrayNewSelect;
                                        //保存数据...
                                        updateItem(row);
                                        refreshFilterData();
                                    }}
                                    className={'tableview-tag default-font-size'}
                                    style={{
                                        backgroundColor: getPropertySelectOptionBackgroundColor(ttttaaaagggggg?.backgroundColor),
                                        marginLeft: '0px',
                                        color:'var(--text-color)'
                                    }}
                                >
                                    {props.label}
                                </Tag>
                            );
                        }, []);

                        /**
                         * 更新属性----
                         */
                        const onUpdateProperty = async (option: any, isDelete = false) => {
                            const arrayNewOptions = [...arraySelectOptions];
                            const nI = arrayNewOptions.findIndex(p => p.id == option.id);
                            if (isDelete) {
                                arrayNewOptions.splice(nI, 1);
                            } else {
                                arrayNewOptions.splice(nI, 1, option);
                            }
                            setArraySelectOptions(arrayNewOptions);


                            const property = await getPropertyById(cell.column.id);
                            const nIndex = property.items.findIndex(p => p.id == option.id);
                            if (isDelete) {
                                property.items.splice(nIndex, 1);
                            } else {
                                property.items.splice(nIndex, 1, option);
                            }
                            await updateProperty(property);


                            //这里--如果是当前选择的，当前选择的也要跟着变化....
                            if (!isDelete) {
                                const arrayNewSelect = [...arraySelectInfo];
                                const newInfo = arrayNewSelect.find(p => p.id == option.id);
                                if (newInfo){
                                    newInfo.text = option.text;
                                    newInfo.backgroundColor = option.backgroundColor;
                                    setArraySelectInfo(arrayNewSelect);
                                    // 保存到数据.
                                    row.original[cell.column.id] = arrayNewSelect;
                                }

                                //更新别的列中的options----
                                //更改cell中所有这个数据..
                                const newTableData:any = {...mTableviewDataRef.current};
                                const arrayDatas:any = [];
                                const arrayColumns:any = [];
                                for (let i=0;i<newTableData.columns.length;i++){
                                    const col = newTableData.columns[i];
                                    if (col.items){
                                        const nIndex = col.items.findIndex(p=>p.id == option.id);
                                        if (nIndex != -1){
                                            col.items.splice(nIndex,1,option);
                                        }
                                    }
                                    arrayColumns.push(col);
                                }
                                newTableData.columns = arrayColumns;

                                for (let i=0;i<newTableData.data.length;i++){
                                    const data = newTableData.data[i];
                                    const arraySelect = data[cell.column.id];
                                    if (isArray(arraySelect)){
                                        //删除这个...
                                        const select = arraySelect.find(p=>p.id == option.id);
                                        if (select){
                                            select.backgroundColor = option.backgroundColor;
                                            select.text = option.text;
                                        }
                                    }
                                    arrayDatas.push(data);
                                }
                                newTableData.data = arrayDatas;
                                setTableData(newTableData);

                                //保存到数据库..
                                updateItem(row);
                                refreshFilterData();
                            }
                        }

                        /**
                         * 更多菜单
                         */
                        const renderMore = (option) => {
                            // const [inputValue,setInputValue] = useState(option.text);//这里面不能这种声明。
                            return <div className={'flex-col'} onMouseDown={(e) => {
                                e.stopPropagation();
                            }} onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                            }}>
                                <input id={`txt-table-view-select-${cell.column.id}`} className={'input-border'}
                                       autoFocus={true}
                                       style={{border: isInputFocus ? '1px solid var(--text-focus-border-color)' : '1px solid var(--input-border-color)'}}
                                       defaultValue={option.text} onFocus={(e) => {
                                    setIsInputFocus(true)
                                }} onBlur={(e) => {
                                    setIsInputFocus(false);
                                    if (e.currentTarget.value) {
                                        //判断是否已经有这个名称了。。。
                                        const hasExist = arraySelectOptions.some(p => p.text.toLowerCase() == e.currentTarget.value.toLowerCase() && p.id != option.id);
                                        if (hasExist) {
                                            message.error(t('DataExists'));
                                        } else {
                                            const newTag = {...option, text: e.currentTarget.value}
                                            onUpdateProperty(newTag);
                                        }
                                    }
                                }} onInput={(e) => {
                                    // setInputValue(e.currentTarget.value);
                                }} onKeyDown={(e) => {
                                    if (e.key == KEYS.ENTER) {
                                        const txt = document.getElementById(`txt-table-view-select-${cell.column.id}`);
                                        txt?.blur();
                                    }
                                }}/>
                                <div className={'flex-row-vertical-center cursor-pointer hovered-gray-radius-3'}
                                     style={{height: '32px', margin: '8px -12px 0px -12px'}} onClick={(e) => {
                                    window.showMessageBox(t("Delete option"), t("SureToDeleteOption"), t("Cancel"), t("Delete"), null, () => {
                                        //删除
                                        const newTag = {...option, text: null};
                                        onUpdateProperty(newTag, true);
                                        const arrayNewSelect = [...arraySelectInfo];
                                        const nIndex = arrayNewSelect.findIndex(p => p.id == newTag.id);
                                        if (nIndex != -1) {
                                            arrayNewSelect.splice(nIndex, 1);
                                            setArraySelectInfo(arrayNewSelect);
                                            // 保存到数据.
                                            row.original[cell.column.id] = arrayNewSelect;
                                            //保存到数据库..
                                            updateItem(row);
                                        }

                                        //从所有cell中移除这个列表...
                                        for (let i=0;i<tableData.columns.length;i++){
                                            if (column.items){
                                                const nIndex = column.items.findIndex(p=>p.id == newTag.id);
                                                if (nIndex != -1){
                                                    column.items.splice(nIndex,1);
                                                }
                                            }
                                        }
                                        //从所有cell数据中移除这个..
                                        const newTableData:any = {...mTableviewDataRef.current};
                                        const arrayDatas = [];
                                        for (let i=0;i<newTableData.data.length;i++){
                                            const data = newTableData.data[i];
                                            const arraySelect = data[cell.column.id];
                                            if (isArray(arraySelect)){
                                                //删除这个...
                                                const nIndex = arraySelect.findIndex(p=>p.id == newTag.id);
                                                if (nIndex != -1){
                                                    arraySelect.splice(nIndex,1);
                                                }
                                            }
                                            arrayDatas.push(data);
                                        }
                                        newTableData.data = arrayDatas;
                                        setTableData(newTableData);
                                    })
                                }}>
                                    <img className={'img-16 ml-20'} src={getImagePathWithThemeSvg('option_delete')}/>
                                    <span className={'ml-8'}>{t('Delete option')}</span>
                                </div>
                                <div className={'line mt-12'} style={{margin: '8px -12px'}}></div>
                                <div className={'mt-2'} style={{
                                    display: 'grid',
                                    padding: '0 8px',
                                    gap: '12px 0',
                                    gridTemplateColumns: 'repeat(4,auto)',
                                    justifyContent: 'space-between'
                                }}>
                                    {
                                        ARRAY_PROPERTY_OPTIONS_COLOR.map(p => {
                                            return <div className={'cursor-pointer'} style={{
                                                width: '32px',
                                                height: '32px',
                                                borderRadius: '8px',
                                                background: `${isDarkMode()?p.useDarkColor:p.color}`
                                            }}  onMouseDown={(e) => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                setTimeout(()=>{
                                                    const newTag = {...option, backgroundColor: p.usedColor};
                                                    onUpdateProperty(newTag).then(r=>{
                                                        const div = document.getElementById('div-select-container-'+cell.column.id);
                                                        if (div){
                                                            div.focus();
                                                            div.click();
                                                        }
                                                    });


                                                },100)
                                            }}>
                                            </div>
                                        })
                                    }
                                </div>

                            </div>
                        }

                        const getSelectText = () => {
                            const arrayTxt = [];
                            for (let i = 0; i < arraySelectInfo?.length; i++) {
                                arrayTxt.push(arraySelectInfo[i].text);
                            }
                            return arrayTxt;
                        }

                        /**
                         * 选择操作.
                         * @param p
                         */
                        const onSelectOption = async (p)=>{
                            setIsEditable(false);
                            if (arraySelectInfo.some(pp => pp.id == p.id)) {
                                //已经有了，返回.
                                return;
                            }

                            if (p.isNew) {
                                //保存到这个自定义属性下的select 中去...
                                const property = await getPropertyById(cell.column.id);
                                if (!property.items) {
                                    property.items = [];
                                }
                                delete p.isNew;
                                property.items.push(p);
                                await updateProperty(property);

                                //加到数据里面....
                                cell.column.columnDef.items.push(p);
                                // mArraySelectInfo.current?.push(p);
                                //恢复原集合.
                                setArraySelectOptions(cell.column.columnDef.items);

                                setTagBackgroundIndexAdd(mCreateNewSelectBackgroundColorIndex.current);
                            }

                            let arrayNewSelect: any = [...arraySelectInfo];
                            if (!isMultipSelect()) {
                                arrayNewSelect = [];
                            }
                            arrayNewSelect.push(p);
                            setArraySelectInfo(arrayNewSelect);

                            row.original[cell.column.id] = arrayNewSelect
                            //保存这个属性...
                            updateItem(row);
                            refreshFilterData();
                        }

                        return <div id={'div-select-container-'+cell.column.id} className={'flex-row-vertical-center td-div-relative tableview-column-style cursor-pointer'}
                                    style={{width: `${cell.column.getSize() - 20}px`, height: '100%',position:isEditable?'absolute':''}} onClick={() => {
                            setIsEditable(true);

                            // setTimeout(()=>{
                            //     const newMap = {...mMapSelectOpenRef.current};
                            //     newMap[row.original.id] = true;
                            //     setMapSelectOpen(newMap);
                            // },100)

                        }}>
                            {
                                (isEditable) ?
                                    <Select
                                        autoFocus={true}
                                        mode={"tags"}
                                        suffixIcon={null}
                                        tagRender={tagRender}
                                        className={'tableview-select'}
                                        variant={"borderless"}
                                        open={true}
                                        onDropdownVisibleChange={(e)=>{
                                            setIsSelectOpen(e);
                                            if (!e) {
                                                setTimeout(() => {
                                                    setIsEditable(false);
                                                }, 200)
                                            }
                                        }}
                                        style={{marginTop:'5px',opacity:isEditable?'1':'1',position: 'absolute'}}
                                        onKeyDown={(e)=>{
                                            if (e.key == KEYS.ENTER){
                                                if (arraySelectOptions.length == 1 /*&& arraySelectOptions[0].isNew*/){
                                                    e.stopPropagation();
                                                    onSelectOption(arraySelectOptions[0]);
                                                }
                                            }else if ((e.key == KEYS.BACKSPACE || e.key == KEYS.DELETE) && !e.target.value){
                                                //删除最后一个..
                                                const arrayNewSelect = [...row.original[cell.column.id]];
                                                if (arrayNewSelect.length > 0){
                                                    const nIndex = arrayNewSelect.length -1;
                                                    arrayNewSelect.splice(nIndex, 1);
                                                    setArraySelectInfo(arrayNewSelect);

                                                    row.original[cell.column.id] = arrayNewSelect;
                                                    //保存数据...
                                                    updateItem(row);
                                                    refreshFilterData();
                                                }
                                            }
                                        }}
                                        onSearch={(e) => {
                                            const szValue = e.toLowerCase();
                                            const arrayNewOptions: any = [];
                                            for (let i = 0; i < cell.column.columnDef.items.length; i++) {
                                                const item = cell.column.columnDef.items[i];
                                                if (item.text.toLowerCase().includes(szValue)) {
                                                    arrayNewOptions.push(item);
                                                }
                                            }
                                            // if (mCreateNewSelectBackgroundColorIndex.current == -1){
                                            //     mCreateNewSelectBackgroundColorIndex.current = getTagBackgroundIndex();
                                            // }
                                            if (arrayNewOptions.length == 0) {
                                                mCreateNewSelectBackgroundColorIndex.current = getTagBackgroundIndex();
                                                //创建一个新的----
                                                arrayNewOptions.push({
                                                    id: generateUUID2(),
                                                    text: e,
                                                    isNew: true,
                                                    sort: 0,
                                                    backgroundColor:ARRAY_PROPERTY_OPTIONS_COLOR[mCreateNewSelectBackgroundColorIndex.current].usedColor
                                                })
                                            }
                                            setArraySelectOptions(arrayNewOptions);
                                        }}
                                        value={getSelectText()}
                                        placeholder={t('SearchForAnOption')}
                                        dropdownClassName={'tableview-dropdown-select'}
                                        dropdownStyle={{maxHeight:`${document.body.clientHeight*0.5}px`,overflow:'auto'}}
                                        dropdownRender={(menus) => {
                                            return <div className={'flex-col'} style={{marginTop: '-2px'}}>
                                                <span className={'ml-12'} style={{color:'var(--color-666666)',minHeight:'32px',lineHeight:'32px',display:'block'}}>{t('SelectAnOption')}</span>
                                                {
                                                    arraySelectOptions?.length == 0?<div className={'flex-row-vertical-center'} style={{color:'var(--text-color-bab8b8)',height:'38px',paddingLeft:'8px'}}>{t('No options')}</div>:
                                                    arraySelectOptions?.map(p => {
                                                        return <div data-id={p.id}
                                                            className={'flex-row-vertical-center cursor-pointer hovered-gray-radius-3'}
                                                            style={{padding: '4px 8px',}}
                                                            onMouseDown={(e) => {
                                                                e.stopPropagation();
                                                            }} onClick={async (e) => {
                                                            e.stopPropagation();
                                                            onSelectOption(p);
                                                            //添加到数据集合.
                                                        }} onMouseEnter={(e) => {
                                                            const arrayNewSelect = [...arraySelectOptions];
                                                            arrayNewSelect.forEach(p => p.isHovered = false);
                                                            p.isHovered = true;
                                                            setArraySelectOptions(arrayNewSelect);
                                                        }} onMouseLeave={(e) => {
                                                            const arrayNewSelect = [...arraySelectOptions];
                                                            arrayNewSelect.forEach(p => p.isHovered = false);
                                                            setArraySelectOptions(arrayNewSelect);
                                                        }}>
                                                            <div>
                                                                {
                                                                    p.isNew &&
                                                                    <label
                                                                        style={{marginRight: '8px'}}>{t('Create')}</label>
                                                                }
                                                                <label className={'tableview-tag cursor-pointer'}
                                                                       style={{
                                                                           background: getPropertySelectOptionBackgroundColor(p.backgroundColor),
                                                                           display: 'inline-block',
                                                                           borderRadius: '4px',
                                                                       }}>{p.text}</label>
                                                            </div>
                                                            {
                                                                <Popover trigger={['click']} content={renderMore(p)}
                                                                         arrow={false}
                                                                         overlayInnerStyle={{width: '200px'}}
                                                                         placement={'rightTop'}
                                                                         open={isSelectMoreOpen[p.id]}
                                                                         onOpenChange={(e)=>{
                                                                             const newMap = {...isSelectMoreOpen};
                                                                             newMap[p.id] = e;
                                                                             setIsSelectMoreOpen(newMap);
                                                                         }}
                                                                         afterOpenChange={(e) => {
                                                                             if (e) {
                                                                                 setTimeout(() => {
                                                                                     const txt = document.getElementById(`txt-table-view-select-${cell.column.id}`);
                                                                                     if (txt) {
                                                                                         txt.focus();
                                                                                     }
                                                                                 }, 20)
                                                                             }
                                                                         }}>
                                                                    <div className={'flex-center'} style={{
                                                                        width: '22px',
                                                                        height: '22px',
                                                                        marginLeft: 'auto'
                                                                    }} onMouseDown={(e) => {
                                                                        e.stopPropagation();
                                                                        e.preventDefault();
                                                                    }} onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        e.preventDefault();
                                                                    }}>
                                                                        {
                                                                            !p.isNew && p.isHovered &&
                                                                            <img style={{}}
                                                                                 className={'img-12 cursor-pointer mr-10'}
                                                                                 src={getImagePathWithTheme('note_card_h_more')}
                                                                            />
                                                                        }

                                                                    </div>

                                                                </Popover>
                                                            }

                                                        </div>
                                                    })
                                                }
                                            </div>
                                        }}
                                    /> : <div key={cell.column.id} className={'flex-row-vertical-center'}
                                              style={{gap: '0 8px'}}>
                                        {
                                            arraySelectInfo.map && arraySelectInfo.map(pp => {
                                                return <span key={pp.id}
                                                             className={'span-single-line tableview-tag'}
                                                             style={{background: getPropertySelectOptionBackgroundColor(pp?.backgroundColor)}}>{pp.text}</span>
                                            })
                                        }
                                    </div>
                            }
                        </div>
                        //endregion--select-mulselect
                    } else if (cell.column.columnDef.type == 'url') {
                        //region link
                        return <div className={'flex-row-vertical-center tableview-column-style cursor-pointer'} onClick={(e) => {
                            const newInputValue = {...customInputTextInfo};
                            newInputValue.isEditable = true;
                            setCustomInputTextInfo(newInputValue);
                            setTimeout(() => {
                                inputTextRef.current?.focus();
                            }, 100)
                        }}
                                    style={{
                                        width: `${cell.column.getSize()}px`,
                                        height: '100%',
                                        position: 'relative'
                                    }}>
                            {
                                customInputTextInfo?.isEditable ?
                                    <textarea ref={inputTextRef} className={'tableview-textarea default-font-size'}
                                              style={{height: `${calcTextareaInCellHeight(cell.column.getSize(), customInputTextInfo.text)}px`}}
                                              value={customInputTextInfo.text} onMouseDown={(e) => {
                                        e.stopPropagation();
                                    }} onInput={(e) => {
                                        const szInput = e.currentTarget.value;

                                        const newInputValue = {...customInputTextInfo};
                                        newInputValue.text = szInput;
                                        newInputValue.type = 'url';
                                        setCustomInputTextInfo(newInputValue);

                                        row.original[cell.column.id] = newInputValue;
                                    }} onBlur={(e) => {
                                        const szInput = e.currentTarget.value;

                                        const newInputValue = {...customInputTextInfo};
                                        newInputValue.isEditable = false;
                                        newInputValue.text = szInput;
                                        setCustomInputTextInfo(newInputValue);
                                        //更新到当前
                                        row.original[cell.column.id] = newInputValue;
                                        updateItem(row);
                                        refreshFilterData();
                                    }} onFocus={(e)=>{
                                        e.currentTarget.setSelectionRange(e.currentTarget.value.length,e.currentTarget.value.length)
                                    }} onKeyDown={(e)=>{
                                        if (e.key == KEYS.ENTER){
                                            e.currentTarget.blur();
                                        }
                                    }}/> :
                                    <>
                                        {
                                            isDeepLink(customInputTextInfo?.text) ?
                                                <CustomDeeplink url={customInputTextInfo?.text}/> :
                                                <span className={'cursor-pointer span-single-line'}
                                                      style={{color: 'var(--color-link)'}} onClick={(e) => {

                                                }}>{customInputTextInfo?.text}</span>
                                        }
                                    </>
                            }

                            <img className={'img-24 cursor-pointer ml-4 operator-icon'}
                                 style={{position: 'absolute', right: '6px',display:customInputTextInfo?.text?'inherit':'none'}}
                                 src={getImagePathWithThemeSvg('tableview_item_open')} onClick={async (e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                let szUrl = customInputTextInfo.text;
                                if (isDeepLink(szUrl)) {
                                    const deeplink = decodeDeeplink(szUrl);
                                    if (deeplink.type == 'library' || deeplink.type == 'highlight') {
                                        postMessage(EVENT_OPEN_LIBRARY_ITEM, {
                                            id: deeplink.id,
                                            from: FROM_LIBRARY,
                                            deeplink: deeplink,
                                            selectedId: deeplink.childId,
                                            inSlider: (e.metaKey || e.ctrlKey)
                                        })
                                        if (deeplink.childType == 'card' || deeplink.childType == 'video' || deeplink.childType == 'pdf' || deeplink.childType == 'highlight') {
                                            if (window.location.href.includes('/card') || window.location.href.includes('/journal')) {
                                                const hasFirst = localStorage.getItem(KEY_IS_FIRST_OPEN_LIBRARY_REF) || 'true';
                                                if (hasFirst == 'true') {
                                                    message.info(t("HoldCtrlDownAndCtrl").replace('Cmd',(isMac()?'Cmd':'Ctrl')));
                                                    localStorage.setItem(KEY_IS_FIRST_OPEN_LIBRARY_REF,'false')
                                                }
                                            }
                                        }
                                    } else {
                                        const linkInfo = await deepLinkToLinkInfo(deeplink);
                                        postMessage(EVENT_SHOW_DIALOG_DRAWINDEX, {linkInfo,inSlider:(e.metaKey || e.ctrlKey)});
                                    }
                                }else {
                                    if (!szUrl.startsWith('http') && !isSupportLink(szUrl)) {
                                        szUrl = 'https://' + customInputTextInfo.text;
                                    }
                                    //打开链接
                                    ipcInvoke('open-url-withwhen', szUrl).then(res => {
                                        if (res == 'error') {
                                            message.error(t("Open error"));
                                        }
                                    })
                                }
                            }}/>

                        </div>
                        //endregion
                    } else if (cell.column.columnDef.type == 'number') {
                        //region number
                        return <div className={'flex-row-vertical-center tableview-column-style cursor-pointer'} onClick={(e) => {
                            const newInputValue = {...customInputTextInfo};
                            newInputValue.isEditable = true;
                            setCustomInputTextInfo(newInputValue);
                            setTimeout(() => {
                                inputTextRef.current?.focus();
                            }, 100)
                        }}
                                    style={{
                                        width: `${cell.column.getSize()}px`,
                                        height: '100%',
                                        position: 'relative'
                                    }}>
                            {
                                customInputTextInfo?.isEditable ?
                                    <textarea ref={inputTextRef} className={'tableview-textarea default-font-size'}
                                              style={{height: `${calcTextareaInCellHeight(cell.column.getSize(), customInputTextInfo.text)}px`}}
                                              value={customInputTextInfo.text} onMouseDown={(e) => {
                                        e.stopPropagation();
                                    }} onInput={(e) => {

                                        let szInput = filterNumericInput(e.currentTarget.value);
                                        // 只允许数字和小数点
                                        // const szInput = szInput.replace(/[^0-9.]/g, '');

                                        const newInputValue = {...customInputTextInfo};
                                        newInputValue.text = szInput;
                                        newInputValue.type = 'number';
                                        setCustomInputTextInfo(newInputValue);

                                        row.original[cell.column.id] = newInputValue;
                                    }} onBlur={(e) => {
                                        const szInput = e.currentTarget.value;
                                        const newInputValue = {...customInputTextInfo};
                                        newInputValue.isEditable = false;
                                        newInputValue.text = szInput;
                                        setCustomInputTextInfo(newInputValue);
                                        //更新到当前
                                        row.original[cell.column.id] = newInputValue;
                                        updateItem(row);
                                        refreshFilterData();
                                    }} onFocus={(e)=>{
                                        e.currentTarget.setSelectionRange(e.currentTarget.value.length,e.currentTarget.value.length)
                                    }} onKeyDown={(e)=>{
                                        if (e.key == KEYS.ENTER){
                                            e.currentTarget.blur();
                                        }
                                    }}/> :
                                    <span style={{marginLeft: 'auto'}}
                                          className={'cursor-pointer span-single-line'}>{customInputTextInfo?.text}</span>
                            }

                        </div>
                        //endregion
                    } else if (cell.column.columnDef.type == 'date') {
                        //region date
                        return <div className={'flex-row-vertical-center tableview-column-style cursor-pointer'} onClick={(e) => {
                            setIsDateEditable(true);
                            setTimeout(() => {
                                inputTextRef.current?.focus();
                            }, 100)
                        }}
                                    style={{
                                        width: `${cell.column.getSize()}px`,
                                        height: '100%',
                                        position: 'relative'
                                    }}>

                            {
                                isDateEditable ?
                                    <Popover arrow={false} open={isDateEditable} align={{offset: [-10, -12]}}
                                             placement={'topLeft'}
                                             content={<PopupDate defaultDate={customInputTextInfo?.text}
                                                                 onDateSelect={(longDate, hasClose = true) => {
                                                                     const newInputValue = {...customInputTextInfo};
                                                                     newInputValue.text = longDate;
                                                                     newInputValue.type = 'date';
                                                                     setCustomInputTextInfo(newInputValue);
                                                                     if (hasClose) {
                                                                         setIsDateEditable(false);
                                                                     }
                                                                     //更新到当前
                                                                     row.original[cell.column.id] = newInputValue;
                                                                     updateItem(row);
                                                                     refreshFilterData();
                                                                 }}/>}>
                                    <span style={{}}
                                          className={'cursor-pointer span-single-line'}>{formatDateCharDesc(customInputTextInfo?.text)}</span>
                                    </Popover> : <span style={{}}
                                                       className={'cursor-pointer span-single-line'}>{formatDateCharDesc(customInputTextInfo?.text)}</span>
                            }

                        </div>
                        //endregion
                    } else if (cell.column.columnDef.type == 'checkbox') {
                        //region checkbox
                        return <div className={'flex-row-vertical-center tableview-column-style'}
                                    style={{
                                        width: `${cell.column.getSize()}px`,
                                        height: '100%',
                                        position: 'relative',
                                        cursor:'pointer'
                                    }} onClick={(e)=>{
                            const szInput = !customInputTextInfo.text;
                            const newInputValue = {...customInputTextInfo};
                            newInputValue.text = szInput;
                            newInputValue.type = 'checkbox';
                            setCustomInputTextInfo(newInputValue);
                            //更新到当前
                            row.original[cell.column.id] = newInputValue;
                            updateItem(row);
                            refreshFilterData();
                        }}>

                            {
                                <Checkbox checked={customInputTextInfo?.text} onChange={(e) => {

                                }}/>
                            }

                        </div>
                        //endregion
                    }else if (cell.column.columnDef.type == 'rating') {
                        //region rating
                        return <div className={'flex-row-vertical-center tableview-column-style'}
                                    style={{
                                        width: `${cell.column.getSize()}px`,
                                        height: '100%',
                                        position: 'relative',
                                        gap:'0 16px',
                                    }}>
                            {
                                [...Array(5)].map((p,index)=>{
                                    return<img className={'img-16 cursor-pointer'} src={getImagePathWithThemeSvg(`column_rate${index<customInputTextInfo?.text?'_selected':''}`)} onClick={(e)=>{
                                        let szInput = index+1;
                                        const newInputValue = {...customInputTextInfo};
                                        if (newInputValue.text == szInput) {
                                            szInput = 0;
                                        }
                                        newInputValue.text = szInput;
                                        newInputValue.type = 'rating';
                                        setCustomInputTextInfo(newInputValue);
                                        //更新到当前
                                        row.original[cell.column.id] = newInputValue;
                                        updateItem(row);
                                        refreshFilterData();
                                    }}/>
                                })
                            }

                        </div>
                        //endregion
                    }
                }
                return <></>
            }
            arrayNewColumns.push(column);

            nWidth += newColumnSizing[column.id];
        }
        const maxWidth = divTableContainerRef.current?.offsetWidth;
        let nSize = maxWidth - nWidth;
        if (nSize < 280){//默认的一个宽度...
            nSize = 280;
        }

        //无论怎么样都加入一个空白列，只是控制宽度....
        arrayNewColumns.push({
            accessorKey: 'empty',
            header:'',
            id: 'empty',
            size:nSize,
            sort:i+'',
            icon:'add_gray_1.svg',
            cell:(info)=>{
                return ''
            }
        })
        newColumnSizing['empty'] = nSize;
        mEmptyColumnWidth.current = newColumnSizing['empty'];


        newTableData.columns = arrayNewColumns;
        newTableData.data = [];

        const arrayDefaults:any = [];
        for (let i=0;i<arrayNewColumns.length;i++){
            arrayDefaults.push(arrayNewColumns[i].id);
        }
        setColumnOrder(arrayDefaults);
        setColumnSizing(newColumnSizing);
        if (mLastViewId.current != props.tableView.id){
            setTableData(newTableData);//先重置一下。。。。
        }

        getProjectByTagName(props.tagName,'',props.szSearchKey).then(async (arrayNotes:any)=> {
            var arrayNewDatas: any = [...arrayNotes];
            //将card的也添加进来...
            const arrayCards: any = await getCardByTagName(props.tagName, '', props.szSearchKey);

            const newNewNewTableData = {...newTableData};
            const arrayNewCols = [];
            for (let i=0;i<newTableData.columns.length;i++){
                arrayNewCols.push({...newTableData.columns[i]});
            }
            newNewNewTableData.columns = arrayNewCols;

            //这里做统计。
            //1.是否包含project
            if (newNewNewTableData.columns.some(p=>p.id == 'project')){
                for (let i=0;i<arrayNewDatas.length;i++){
                    //这里难道要查找被引用的？？？？
                    arrayNewDatas[i].type = 'project';
                    arrayNewDatas[i].arrayInProjects = [arrayNewDatas[i]];//自己
                }
                //这里要统计所在的project
                for (let i=0;i<arrayCards.length;i++){
                    const card = arrayCards[i];
                    card.arrayInProjects = [];
                    let arrayProjects:any = await getNoteList();
                    for (let j=0;j<arrayProjects.length;j++){
                        const doc = await getNoteJsonDoc(arrayProjects[j].id);
                        loopAllNodeWithReturn(doc.canvas,(node)=>{
                            if (node.drawJson?.elements){
                                const element = node.drawJson.elements.find(p=>p.customData?.generationData?.pdfData?.id == card.id || p.customData?.generationData?.videoData?.id == card.id || p.customData?.generationData?.id == card.id);
                                if (element){
                                    //所在项目.
                                    arrayProjects[j].boardId = node.key;
                                    arrayProjects[j].elementId = element.id;
                                    card.arrayInProjects.push(arrayProjects[j]);
                                    return false;
                                }
                            }
                            return true;
                        })
                    }
                }
            }
            arrayNewDatas.push(...arrayCards);

            //将board也加进来
            const arrayBoards:any = await getBoardByTagName(props.tagName,'',props.szSearchKey);
            for (let i=0;i<arrayBoards.length;i++){
                const board = arrayBoards[i];
                const project = await getProjectById(board.projectId);
                board.projectName = project?.name;
                const projectDoc = await getNoteJsonDoc(board.projectId);
                const nodes = findNodeWithParents(projectDoc.canvas,board.id);
                board.parentNodes = nodes?.parents;
            }
            arrayNewDatas.push(...arrayBoards);

            //这里处理select-mulselect的数据
            for (let i=0;i<arrayNewDatas.length;i++){
                const item = arrayNewDatas[i];
                //是否有包含select-mulselect列...
                for (let j=0;j<arrayNewCols.length;j++){
                    const col = arrayNewCols[j];
                    if (col.items){
                        if (item[col.id]){
                            //有属性列，比对里面的元素.
                            const arraySelect = item[col.id];
                            for (let k=arraySelect.length-1;k>=0;k--){
                                const select = arraySelect[k];
                                const propertySelect = col.items.find(p=>p.id == select.id);
                                if (propertySelect){
                                    select.backgroundColor = propertySelect.backgroundColor;
                                    select.text = propertySelect.text;
                                }else{
                                    //没有，就删除
                                    arraySelect.splice(k,1);
                                }
                            }
                        }
                    }
                }
            }

            mDatasMap[props.tagName] = arrayNewDatas;
            let arrayData1 = await applySearchKey(mszSearchKeyRef.current,arrayNewDatas,newNewNewTableData.columns);
            newNewNewTableData.data = await applyFilterTableView(arrayData1);
            handleAddDataColumn(newNewNewTableData);
            if (!mLastViewId.current || mLastViewId.current == props.tableView.id)
            {
                setTableData(newNewNewTableData);
            }

            const sortIds = {};
            //保存序列
            for (let i=0;i<newNewNewTableData.data.length;i++){
                const item = newNewNewTableData.data[i];
                sortIds[item.id] = i;
            }
            props.tableView.sortIds = sortIds;
            updateView(props.tableView);

            setIsLoading(false);
        });
        mLastViewId.current = props.tableView.id;
    }


    function handleDragStart(event:DragStartEvent){
        // if (event.active.id == 'empty'){
        //     event?.activatorEvent.stopPropagation();
        //     return;
        // }

        console.log('handleDragStart')
    }

    function handleDragMove(event:DragMoveEvent){
        // console.log(event);
        if (event.over?.id == 'name' || event.over?.id == 'empty'){
            event?.activatorEvent.preventDefault();
        }
        console.log('handleDragMove')
        if (window.hiddenOpenMore){
            window.hiddenOpenMore();
        }
    }

    function handleDragOver(event:DragOverEvent){
        // console.log(event);
        // if (event?.over?.id == 'name'){
        //     event.over.disabled = true;
        //     event?.activatorEvent.stopImmediatePropagation();
        //     event?.activatorEvent.preventDefault();
        // }
        console.log('handleDragOver')
    }

    // reorder columns after drag & drop
    function handleDragEnd(event: DragEndEvent) {
        const { active, over } = event
        if (over?.id == 'name' || over?.id == 'empty')return;
        if (active && over && active.id !== over.id) {
            const oldIndex = columnOrder.indexOf(active.id as string)
            const newIndex = columnOrder.indexOf(over.id as string)
            const arrayNewColumnOrder = arrayMove(columnOrder, oldIndex, newIndex) //this is just a splice util
            // setColumnOrder(columnOrder => {
            //     const oldIndex = columnOrder.indexOf(active.id as string)
            //     const newIndex = columnOrder.indexOf(over.id as string)
            //     return arrayMove(columnOrder, oldIndex, newIndex) //this is just a splice util
            // })
            setColumnOrder(arrayNewColumnOrder);
            //保存到数据库...
            const newView = {...props.tableView};
            const arrayNewColumns = [];
            for (let i=0;i<arrayNewColumnOrder.length;i++){
                const item = newView.columns.find(p=>p.id == arrayNewColumnOrder[i]);
                if (item){
                    arrayNewColumns.push(item);
                }
            }
            newView.columns = arrayNewColumns;
            props.tableView.columns = arrayNewColumns;
            updateView(newView);
        }
    }

    /**
     * 取排序的字段..
     */
    const getSortValue = (objValue)=>{
        if (!objValue)return '';
        if (isString(objValue)){
            return objValue;
        }
        if (isIntType(objValue)){
            return objValue;
        }
        if (isArray(objValue)){
            //select  mulselect
            if (objValue.length > 0){
                if (isString(objValue[0])){
                    return objValue[0];
                }
                return objValue[0].text || '';
            }
            return '';
        }
        return objValue?.text || '';
    }

    /**
     * 排序列数据.
     * @param header
     * @param sort
     */
    const sortColumnDatas = (header,sort)=>{
        const newTableData = {...tableData};
        const arrayNewDatas:any = [];
        for (let i=0;i<newTableData.data.length;i++){
            arrayNewDatas.push({...newTableData.data[i]})
        }
        sortByColumnDatas(header,sort,arrayNewDatas);
        newTableData.data = arrayNewDatas;
        setTableData(newTableData);
    }

    /**
     * 只排序数据....
     * @param header
     * @param sort
     * @param arrayNewDatas
     */
    const sortByColumnDatas = (header,sort,arrayNewDatas)=>{
        //有新的数据，有旧的数据，从库中添加的数据又不能指定另外的时间，只能重新维护一个tableview的列表。取数据的时候按这个列表id重新排列..
        if (props.tableView.sortIds && Object.keys(props.tableView.sortIds).length > 0){
            arrayNewDatas.sort((a,b)=>{
                let aa = props.tableView.sortIds[a.id] ?? Number.MAX_VALUE;
                let bb = props.tableView.sortIds[b.id] ?? Number.MAX_VALUE;
                return aa - bb;
            })
            return;
        }
        if (sort == 'sortAZ'){
            arrayNewDatas.sort((a,b)=>{
                let aa = getSortValue(a[getColumnDataRef(header.id)]);
                let bb = getSortValue(b[getColumnDataRef(header.id)]);

                //******如果是空的，就强制排到最下面************************************。

                const property = a[getColumnDataRef(header.id)];
                if (property?.type == 'number' || property?.type == 'rating'){

                    if (isString(aa) && aa){
                        aa = getSafeFloat(aa);
                    }
                    if (isString(bb) && bb){
                        bb = getSafeFloat(bb);
                    }

                    if (!aa){
                        aa = Number.MAX_VALUE;
                    }
                    if (!bb){
                        bb = Number.MAX_VALUE;
                    }

                    return aa - bb;
                }else if (property?.type == 'checkbox'){
                    if (aa) {
                        return 1;
                    }
                    return -1;
                }else if (property?.type == 'date' || header.id == 'createTime' || header.id == 'updateTime'){
                    if (!aa){
                        aa = Number.MAX_VALUE;
                    }
                    if (!bb){
                        bb = Number.MAX_VALUE;
                    }

                    return aa - bb;
                }
                if (!aa){
                    aa = '\u{10FFFF}'
                }
                if (!bb){
                    bb = '\u{10FFFF}'
                }
                return aa.localeCompare(bb);
            })
        }else if (sort == 'sortZA'){
            arrayNewDatas.sort((a,b)=>{
                const aa = getSortValue(a[getColumnDataRef(header.id)]);
                const bb = getSortValue(b[getColumnDataRef(header.id)]);

                const property = a[getColumnDataRef(header.id)];
                if (property?.type == 'number' || property?.type == 'rating'){
                    return bb - aa;
                }else if (property?.type == 'checkbox'){
                    if (bb)return 1;
                }else if (property?.type == 'date' || header.id == 'createTime' || header.id == 'updateTime'){
                    return bb - aa;
                }
                return bb.localeCompare(aa);
            })
        }
    }

    /**
     * 更新排序....
     * @param id
     * @param sort
     */
    const saveSortColumn = (id,sort)=>{
        props.tableView.sortColumn = {id:id,sort:sort}
        updateView(props.tableView);
    }

    const handleDeleteColumn = async (deleteColumn:any,newView:any)=>{
        //删除列的时候要遍历所有的数据，看看这个列是否还有在别的tag中的别的视图图是否还有。如果没有就删了这个列
        if (deleteColumn && deleteColumn.groupName == 'custom'){
            const arrayLibrarys:any = [];
            const arrayProjects:any = [];
            for (let i=0;i<newView.data.length;i++){
                let hasExistColumn = false;
                const data = newView.data[i];
                //取这个数据的所有tags
                for (let j=0;j<data.tags.length;j++){
                    const arrayViews = await getViewList(data.tags[j]);
                    for (let k=0;k<arrayViews.length;k++){
                        if (arrayViews[k].id == newView.id)continue;//非当前视图
                        const hasExist = arrayViews[k].columns.some(p=>p.id == deleteColumn.id);
                        if (hasExist){
                            hasExistColumn = true;
                            break;
                        }
                    }
                    if (hasExistColumn){
                        break;
                    }
                }
                if (!hasExistColumn){
                    //删除这个列.
                    delete data[deleteColumn.id];
                    if (data.type && data.type != 'project'){
                        arrayLibrarys.push(data);
                    }else{
                        arrayLibrarys.push(data);
                    }
                }
            }
            if (arrayLibrarys.length >0){
                batchUpdateCard(arrayLibrarys);
            }
            if (arrayProjects.length >0){
                batchUpdateProject(arrayProjects);
            }
        }
    }

    const isTextProperty = (szType)=>{
        return szType == 'text';
    }
    /**
     * 粘贴到列
     */
    const pasteToColumn = async (header:any)=>{
        navigator.clipboard.read().then(async (clipboardItems) => {
            for (const clipboardItem of clipboardItems) {
                    if (clipboardItem.types.includes('text/plain')){
                        let szText:any = await clipboardItem.getType('text/plain');
                        szText = await szText.text();
                        if (!szText)return;
                        const arrayProjects:any = [];
                        const arrayLibrarys:any = [];
                        const arrayBoards:any = [];
                        const arrayColumnsText = szText.split('\n');

                        const sortIds:any = {};
                        for (let i=0;i<arrayColumnsText.length;i++){
                            const szSplitText = arrayColumnsText[i];
                            let item;
                            if (i < tableData.data.length){
                                item = tableData.data[i];
                            }else{
                                //创建一个新条目..
                                item = {
                                    id:generateUUID2(),
                                    isDeleted:0,
                                    type:'row',
                                    createTime:Date.now()+i,
                                    updateTime:Date.now()+i,
                                    tags:[props.tagName],
                                    name:''
                                }
                            }
                            sortIds[item.id] = i;

                            if (DEFAULT_PROPERTY.some(p => p.id == header.id)) {
                                item[header.id] = szSplitText;
                            } else {
                                if (!item[header.id]) {
                                    item[header.id] = {
                                        header:header.name,
                                        height:47,
                                        isEditable:false,
                                        text:'',
                                        type:'text'
                                    }
                                }
                                item[header.id].text = szSplitText;
                            }
                            if (item.type == 'project') {
                                arrayProjects.push(item);
                            } else if (item.type == 'board') {
                                arrayBoards.push(item);
                            } else {
                                arrayLibrarys.push(item);
                            }
                        }

                        batchUpdateProject(arrayProjects);
                        batchUpdateBoard(arrayBoards);
                        batchUpdateCard(arrayLibrarys);
                        props.tableView.sortIds = sortIds;
                        refreshData();
                    }
            }
        });

    }
    /**
     * 列头的菜单
     * @param header
     */
    const renderHeaderPopoverContent = (header)=>{
        const arrayMenus = [
            {
                id:'edit',
                name:t('Edit'),
                icon:'column_sort_edit.svg',
                disabled:header.column.columnDef.groupName == 'default'
            },
            {
                id:'sortAZ',
                name:t('SortAZ'),
                icon:'column_sort_a_z.svg'
            },
            {
                id:'sortZA',
                name:t('SortZA'),
                icon:'column_sort_z_a.svg'
            },
            {
                id:'sep',
                type:'sep',
            },
            // {
            //     id:'copyColumn',
            //     name:t('Copy column'),
            //     icon:'column_copy.svg'
            // },
            // {
            //     id:'pasteColumn',
            //     name:t('Paste column'),
            //     icon:'column_paste.svg'
            // },
            // {
            //     id:'clearColumn',
            //     name:t('Clear column'),
            //     icon:'column_clear.svg'
            // },
            // {
            //     id:'sep',
            //     type:'sep',
            // },
            {
                id:'delete',
                name:t('Remove'),
                icon:'column_delete.svg',
                disabled:header.id == 'name'
            }
        ]

        //只有文本属性的带粘贴..
        const pasteColumn:any = arrayMenus.find(p=>p.id == 'pasteColumn');
        if (pasteColumn && !isTextProperty(header.column.columnDef?.type)){
            pasteColumn.disabled = true;
        }

        return <div className={'flex-col'}>
            {
                arrayMenus.map(p=>{
                    return(
                        p.type == 'sep'?<div className={'line'}></div>:
                            <div key={p.id} className={'flex-row-vertical-center dropdown-item default-font-size'}
                                 style={{
                                     padding: '0px 12px',
                                     margin: '2px 0px',
                                     opacity: p.disabled ? '0.5' : '1',
                                     cursor: p.disabled ? 'not-allowed' : 'pointer'
                                 }} onClick={async () => {
                                if (p.id == 'sortAZ') {
                                    sortColumnDatas(header, p.id);
                                    //保存这个排序...
                                    saveSortColumn(header.id, p.id);
                                } else if (p.id == 'sortZA') {
                                    sortColumnDatas(header, p.id);
                                    //保存这个排序...
                                    saveSortColumn(header.id, p.id);
                                } else if (p.id == 'delete') {
                                    if (p.disabled) return;

                                    const newView = {...mTableviewDataRef.current};
                                    const arrayNewColumns: any = [];
                                    let deleteColumn: any = null;
                                    for (let i = 0; i < newView.columns.length; i++) {
                                        const item = newView.columns[i];
                                        if (item.id != header.id) {
                                            arrayNewColumns.push(item);
                                        } else {
                                            deleteColumn = item;
                                        }
                                    }
                                    newView.columns = arrayNewColumns;
                                    setTableData(newView);

                                    getViewById(newView.id).then(res => {
                                        //刷新tableview列表
                                        const nIndex = res.columns.findIndex(pp => pp.id == header.id);
                                        if (nIndex != -1) {
                                            res.columns.splice(nIndex, 1);
                                            updateView(res).then(rrr => {
                                                //这里要去刷新外部的列表中的数据.
                                                window.globalRefreshList('refresh_tag_view_list_');
                                            });
                                        }
                                    });

                                    //删除列的操作.--- 又不用删除这个属性了。继续保留.
                                    // handleDeleteColumn(deleteColumn,newView);
                                } else if (p.id == 'edit') {
                                    if (p.disabled) return;
                                    getPropertyById(header.id).then(property => {
                                        window.showDialogAddProperty(property, (newProperty) => {
                                            //刷新这个列头...
                                            const newTable = {...tableData};
                                            const arrayColumns = [...newTable.columns];
                                            const column = arrayColumns.find(ppp => ppp.id == header.id);
                                            column.name = column.header = newProperty.name;
                                            if (newProperty.type == 'select' || newProperty.type == 'multiSelect') {
                                                column.items = newProperty.items;
                                            }
                                            newTable.columns = arrayColumns;
                                            setTableData(newTable);
                                            //这里还有个重命名，真的是，到处都有..
                                            //刷新filter中的....
                                            for (let i = 0; i < props.tableView.columns.length; i++) {
                                                const col = props.tableView.columns[i];
                                                const newCol = arrayColumns.find(p => p.id == col.id);
                                                if (newCol) {
                                                    col.name = col.header = newCol.name;
                                                    if (newCol.type == 'select' || newCol.type == 'multiSelect') {
                                                        col.items = newCol.items;
                                                    }
                                                }
                                            }
                                        })
                                    })
                                }else if (p.id == 'copyColumn') {
                                    let szTxt = '';
                                    for (let i=0;i<tableData.data.length;i++){
                                        const item = tableData.data[i];
                                        if (DEFAULT_PROPERTY.some(p=>p.id == header.id)){
                                            szTxt += (item[header.id] || '') + '\n';
                                        }else {
                                            szTxt += (item[header.id]?.text || '') + '\n';
                                        }
                                    }
                                    if (szTxt.length > 0){
                                        szTxt = szTxt.substring(0,szTxt.length - 1);
                                    }
                                    clipboard.write(szTxt);
                                    message.info(t('Copied to clipboard'));
                                    window.hiddenOpenMore();
                                }else if (p.id == 'pasteColumn'){
                                    document.body.focus();
                                    setTimeout(()=>{
                                        pasteToColumn(header);
                                    },200);

                                }else if (p.id == 'clearColumn'){
                                    //清空这个数据...
                                    const arrayProjects:any = [];
                                    const arrayLibrarys:any = [];
                                    const arrayBoards:any = [];
                                    for (let i=0;i<tableData.data.length;i++){
                                        const item = tableData.data[i];
                                        if (isAnnoType(item.type))continue;
                                        if (DEFAULT_PROPERTY.some(p=>p.id == header.id)){
                                            item[header.id] = '';
                                        }else {
                                            if (item[header.id]){
                                                if (isArray(item[header.id])){
                                                    item[header.id] = [];
                                                }else {
                                                    item[header.id].text = '';
                                                }
                                            }
                                        }
                                        if (item.type == 'project'){
                                            arrayProjects.push(item);
                                        }else if (item.type == 'board'){
                                            arrayBoards.push(item);
                                        }else {
                                            arrayLibrarys.push(item);
                                        }
                                        batchUpdateProject(arrayProjects);
                                        batchUpdateBoard(arrayBoards);
                                        batchUpdateCard(arrayLibrarys);
                                        refreshData();
                                    }
                                }
                            }}>
                                <img className={'img-14'} src={getImagePathWithTheme(p.icon)}/>
                                <span className={'ml-8'}>{p.name}</span>
                            </div>
                    )
                })
            }
        </div>
    }

    const DraggableTableHeader = ({header,}: {
        header: Header<any, unknown>
    }) => {
        const { attributes, isDragging, listeners, setNodeRef, transform } =
            useSortable({
                id: header.column.id,
            })
        const disabled = (header.column.id == 'name' || header.column.id == 'empty' || header.column.id == 'checked');
        const [isOpenMore,setIsOpenMore] = useState(false);

        useEffect(() => {
            window.hiddenOpenMore = ()=>{
                setIsOpenMore(false);
            }
            return ()=>{
                delete window.hiddenOpenMore;
            }
        }, [isOpenMore]);

        const style: CSSProperties = {
            opacity: isDragging ? 0.8 : 1,
            position: 'relative',
            transform: CSS.Translate.toString(transform), // translate instead of transform to avoid squishing
            transition: 'width transform 0.2s ease-in-out',
            whiteSpace: 'nowrap',
            // width: header.column.getSize(),
            zIndex: isDragging ? 1 : 0,
            // background:'var(--table-view-header-background-color)'
        }

        const szHeaderImg = (getHeaderColumnIcon(header));

        const hasChecked = ()=>{
            const arrayValues = Object.values(rowChecked);
            return arrayValues.some(p=>p);
        }

        const hasCheckAll = ()=>{
            const arrayValues = Object.values(rowChecked);
            if (arrayValues.length == 0)return false;
            return arrayValues.filter(p=>p).length == tableData.data.length;
        }

        return (
            <Popover arrow={false} placement={'bottom'} open={isOpenMore}
                     onOpenChange={(e)=> {
                         if (header.id == 'empty' || header.id == 'checked') {
                             setIsOpenMore(false);
                             return;
                         }
                         setIsOpenMore(e)
                     }}
                     align={{offset:[0,0]}}
                     overlayInnerStyle={{padding:'2px 0',minWidth:'150px', width:`${header.column.getSize()}px`,}}
                     trigger={['click']} content={renderHeaderPopoverContent(header)}>
                <th className={'view-header th-style'} ref={setNodeRef} onMouseDown={(e)=>{
                    if (header.id == 'empty' || header.id == 'checked') {
                        setIsOpenMore(false)
                    }else{
                        setTimeout(()=>{
                            setIsOpenMore(!isOpenMore);
                        },200)
                    }
                }}
                    {...{
                        key: header.id,
                        colSpan: header.colSpan,
                        style: {
                            ...style,
                            width: header.getSize(),
                            minWidth:header.getSize(),
                        },
                    }}>
                    <div className={'flex-row'} style={{width: header.getSize() - 8,cursor:'pointer'}}>
                        {
                            header.id == 'name' && hasChecked()&&
                            <div style={{position: 'absolute', top: '9px'}} onMouseDown={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                            }} onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                            }}>
                                {
                                    // <Checkbox className={'checkbox--first checkbox-custom'}
                                    //        indeterminate={hasChecked() && !hasCheckAll()}
                                    //        checked={hasCheckAll()}
                                    //        onChange={(e) => {
                                    //            const newMap = {...rowChecked};
                                    //            for (let i = 0; i < tableData.data.length; i++) {
                                    //                newMap[i] = e.target.checked;
                                    //            }
                                    //            setRowChecked(newMap);
                                    //            props.onRefreshCheck(newMap);
                                    //        }}/>

                                    // <img className={'checkbox-first-0 img-18 cursor-pointer'}
                                    //      style={{opacity:'1'}}
                                    //      src={getImagePathWithThemeSvg(`${hasCheckAll() ? 'table_view_checked' : 'table_view_uncheck'}`)}
                                    //      onClick={(e) => {
                                    //          const newMap = {...rowChecked};
                                    //          let isCheckedAll = !hasCheckAll();
                                    //         for (let i = 0; i < tableData.data.length; i++) {
                                    //             newMap[i] = isCheckedAll;
                                    //         }
                                    //         setRowChecked(newMap);
                                    //         props.onRefreshCheck(newMap);
                                    //      }}
                                    // />
                                }


                            </div>
                        }

                        <div className={'flex-row-vertical-center tableview-header-padding'} style={{
                            padding: header.id == 'name' ? '0 8px' : '0 8px',
                            flexGrow: '1',
                            overflow: header.id == 'empty' ? '' : 'hidden'
                        }} {...(!disabled && attributes)} {...(!disabled && listeners)}>
                            {
                                szHeaderImg &&
                                <>
                                    {
                                        header.id == 'empty' ? <Popover arrow={false} trigger={['click']}
                                                                        open={isAddPropertyOpen}
                                                // align={{offset: [-35, 36]}}
                                                // placement={'rightBottom'}
                                                                        align={{offset: [113, 0]}}
                                                                        overlayInnerStyle={{
                                                                            minWidth: '260px',
                                                                            maxWidth: '260px',
                                                                            padding: '12px 0px'
                                                                        }}
                                                                        onOpenChange={(e) => {
                                                                            setIsAddPropertyOpen(e);
                                                                        }}
                                                                        content={<PropertyContentInfo
                                                                            selectView={props.tableView}
                                                                            onClosePopover={()=>{
                                                                                setIsAddPropertyOpen(false);
                                                                            }}
                                                                            addNewPropertyToTableView={props.addNewPropertyToTableView}/>}>
                                                <div className={'hovered-light-noradius flex-center'} style={{width:'36px',height:'36px',marginLeft:'-12px',marginTop:'-2px',marginBottom:'-2px'}} onMouseDown={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    setIsAddPropertyOpen(true)
                                                }}>
                                                    <img className={'img-16 cursor-pointer'}
                                                         style={{}}
                                                         src={getImagePathWithThemeSvg(szHeaderImg)} />
                                                </div>
                                            </Popover> :
                                            <img className={'img-16 mr-8'}
                                                 style={{marginRight: szHeaderImg.includes('property_text') ? '5px' : '8px'}}
                                                 src={getImagePathWithThemeSvg(szHeaderImg)}/>
                                    }
                                </>
                            }

                            {
                                header.id == 'checked' &&
                                <img className={'checkbox-first-0 img-18 cursor-pointer'}
                                     style={{opacity:'1'}}
                                     src={getImagePathWithThemeSvg(`${hasCheckAll() ? 'table_view_checked' : 'table_view_uncheck'}`)}
                                     onMouseDown={(e) => {
                                         const newMap = {...rowChecked};
                                         let isCheckedAll = !hasCheckAll();
                                        for (let i = 0; i < tableData.data.length; i++) {
                                            newMap[i] = isCheckedAll;
                                        }
                                        mRowCheckedRef.current = newMap;
                                        setRowChecked(newMap);
                                        props.onRefreshCheck(newMap);
                                     }}
                                />
                            }

                            <span className={'span-single-line'} style={{}}>
                                {header.isPlaceholder
                                    ? null
                                    : flexRender(header.column.columnDef.header, header.getContext())}
                            </span>

                        </div>
                    </div>

                    <div
                        {...{
                            onDoubleClick: () => header.column.resetSize(),
                            onMouseDown: header.getResizeHandler(),
                            onTouchStart: header.getResizeHandler(),
                            className: `resizer ${
                                table.options.columnResizeDirection
                            } ${
                                header.column.getIsResizing() ? 'isResizing' : ''
                            }`,
                            style: {
                                zIndex: '2',
                                height:'100%',
                                // flexShrink: '0',
                                transform:
                                    columnResizeMode === 'onEnd' &&
                                    header.column.getIsResizing()
                                        ? `translateX(${
                                            (table.options.columnResizeDirection ===
                                            'rtl'
                                                ? -1
                                                : 1) *
                                            (table.getState().columnSizingInfo
                                                .deltaOffset ?? 0)
                                        }px)`
                                        : '',
                            },
                        }}
                    />
                </th>
            </Popover>
        )
    }

    /**
     * 条目的更多菜单
     */
    const refreshItemMenu = (data:any)=>{
        return new Promise(resolve => {
            let arrayMenus:any;
            if (data.type == 'project'){
                arrayMenus = createProjectItemMenu(data,async (key)=>{
                    if (data.isFavirated == 1){
                        data.isFavirated = 0;
                    }else{
                        data.isFavirated = 1;
                    }
                    data.favirateTime = new Date().getTime();
                    //把这个data插入到文件夹下...
                    await updateFavorToFolder(key,data);

                    updateNote(data).then(res=>{
                        postMessage(EVENT_FAVIRIATE_CHANGE);
                        // setMenuItems(createMenu());
                        // callback()
                    })
                })
            }else if (data.type == 'board'){
                arrayMenus = createBoardItemMenu(data,async (key)=>{
                    if (data.isFavirated == 1){
                        data.isFavirated = 0;
                    }else{
                        data.isFavirated = 1;
                    }
                    data.favirateTime = new Date().getTime();
                    //把这个data插入到文件夹下...
                    await updateFavorToFolder(key,data);

                    updateBoard(data).then(res=>{
                        postMessage(EVENT_FAVIRIATE_CHANGE);
                    })
                })
            }
            else{
                arrayMenus = createLibraryItemMenu(FROM_LIBRARY,false,data,async (key)=>{
                    if (data.isFavirated){
                        data.isFavirated = 0;
                    }else{
                        data.isFavirated = 1;
                    }
                    data.favirateTime = Date.now();
                    //更新到favorfolder
                    //把这个data插入到文件夹下..
                    await updateFavorToFolder(key,data);

                    updateCard(data,false).then(res=>{
                        postMessage(EVENT_FAVIRIATE_CHANGE);
                        // if (props.onRefreshList){
                        //     props.onRefreshList();
                        // }
                    });
                });
            }

            mArrayMenuItems.current.length = 0;
            mArrayMenuItems.current.push(...arrayMenus);

            setMenuItems(arrayMenus);

            resolve('ok')
        })
    }

    /**
     * 条目的更多菜单-----
     */
    const reContextMenu = async (e,data)=>{
        if (e) {
            await refreshItemMenu(data);
        }

        const menu:any = [...mArrayMenuItems.current];

        //判断一下文件是否存在..
        if (data.type == 'pdf' || data.type == 'audio' || data.type == 'video') {
            let szFilePath = data.fileName;
            if (!data.isAbsolutePath) {
                szFilePath = localStorage.getItem(KEY_FILE_DIR) + data.fileName;
            }
            const isExist = await ipcInvoke('is-file-exist', {filePath: szFilePath});
            if (!isExist && !menu.some(p => p.key == 'changeSource')){
                menu.splice(0, 0, {
                    label: t("Change source"),
                    key: 'changeSource',
                    icon: <IconChangeSource/>
                })
            }
        }

        setMenuItems(menu);
    }

    /**
     * 右键菜单，转到上级去处理
     * @param e
     */
    const handleMenuClick = async (e: any) => {
        if (mCurrentMoreData.current.type == 'project'){
            onProjectItemClick(e.key,mCurrentMoreData.current,()=>{

            });

        }else if (mCurrentMoreData.current.type == 'board'){
            onBoardItemClick(e.key,mCurrentMoreData.current,()=>{

            })
        }
        else{
            if (e.key == 'hiddenVisibleFromLibrary'){
                //显示或隐藏这个.
                if (mCurrentMoreData.current.isHidden == 1){
                    mCurrentMoreData.current.isHidden = 0;
                }else{
                    mCurrentMoreData.current.isHidden = 1;
                }
                //更新并刷新.
                updateCard(mCurrentMoreData.current).then(res=>{
                    window.globalRefreshList('refreshLibraryList_');
                })
            }else{
                // props.onActionCallback(e.key,props.data);
                onCardItemClick(e.key,mCurrentMoreData.current,()=>{

                })
            }
        }

    }

    /**
     * 右键菜单，添加到收藏的文件夹处理....
     * @param id
     * @param data
     */
    const patchMenuFavor = (data)=>{
        setTimeout(()=>{
            const arrayMenus = document.getElementsByClassName('ant-dropdown-menu-submenu-title');
            for (let i=0;i<arrayMenus.length;i++){
                const item = arrayMenus[i];
                if (item.dataset?.menuId?.endsWith('-favor')){
                    item.onclick = function (event:any){
                        //这里是添加到根
                        handleMenuClick({key:'favor'});
                        const newMap = {...mapIsColumnMoreOpen};
                        newMap[`column-more-${data.id}`] = false;
                        setMapIsColumnMoreOpen(newMap);
                    }
                }
            }
        },100)
    }

    const DragAlongCell = ({cell,row,rowIndex}: { cell: Cell<any, unknown> ,row:any,rowIndex:any}) => {
        const {isDragging, setNodeRef, transform} = useSortable({
            id: cell.column.id,
        })

        const style: CSSProperties = {
            opacity: isDragging ? 0.8 : 1,
            // position: 'relative',//这个属性影响---textarea  在下一行的输入点击
            transform: CSS.Translate.toString(transform), // translate instead of transform to avoid squishing
            transition: 'width transform 0.2s ease-in-out',
            // width: cell.column.getSize(),
            zIndex: isDragging ? 1 : 0,
        }

        /**
         * 可以在右侧栏打开的.
         */
        const isCanOpenIsSlider = ()=>{
            if (row.original.type == 'card' ||
                row.original.type == 'pdf' ||
                row.original.type == 'video' ||
                row.original.type =='project' ||
                row.original.type == 'board' ||
                row.original.type == 'liveVideo' ||
                row.original.type == 'audio'){
                return true;
            }
            if (row.original.type == 'row'){
                if (isDeepLink(row.original.link) && !isDeeplinkLocate()){
                    return true;
                }
            }
            return false;
        }

        const isCanLocate = ()=>{
            return isAnnoType(row.original.type);
        }

        /**
         * 是row.并且非deeplink链接
         */
        const isRowOtherLink = ()=>{
            return (row.original.type == 'row' && !isDeepLink(row.original.link));
        }

        const isDeeplinkLocate = ()=>{
            if (isDeepLink(row.original.link)){
                const deeplink = decodeDeeplink(row.original.link);
                return isAnnoType(deeplink.childType);
            }
            return false;
        }


        return (
            <>
                <td ref={setNodeRef}  {...{
                    key: cell.id,
                    style: {
                        ...style,
                        width: cell.column.getSize(),
                        maxWidth:cell.column.getSize(),
                        overflow:(cell.column.columnDef.type == 'select' || cell.column.columnDef.type == 'multiSelect')?'hidden':''
                    },
                }} className={'td-name-icon'}>
                    {
                        cell.column.id == 'name' ?
                            <div className={'flex-row-vertical-center td-div-relative tableview-column-style'} style={{position:'relative'}}>
                                {
                                    // <Checkbox className={'checkbox-first'}
                                    //        style={{opacity: rowChecked[rowIndex] ? 1 : 0/*visibility:(rowChecked[rowIndex] || mapIsRowHovered[rowIndex])?'visible':'hidden'*/}}
                                    //        checked={rowChecked[rowIndex]}
                                    //        onChange={(e) => {
                                    //            const newRowCheck = {...rowChecked};
                                    //            newRowCheck[rowIndex] = e.target.checked;
                                    //            setRowChecked(newRowCheck);
                                    //            //如果有选择的，就显示选项
                                    //            props.onRefreshCheck(newRowCheck)
                                    //        }}/>

                                    // <img className={'checkbox-first img-18 cursor-pointer'}
                                    //      style={{opacity: rowChecked[rowIndex] ? 1 : 0/*visibility:(rowChecked[rowIndex] || mapIsRowHovered[rowIndex])?'visible':'hidden'*/}}
                                    //      src={getImagePathWithThemeSvg(`${rowChecked[rowIndex]?'table_view_checked':'table_view_uncheck'}`)}
                                    //      onClick={(e)=>{
                                    //          const newRowCheck = {...rowChecked};
                                    //         newRowCheck[rowIndex] = (!(newRowCheck[rowIndex] || false));
                                    //         if (e.shiftKey){
                                    //             //选中当前和前面
                                    //             const arrayKeys = Object.keys(newRowCheck);
                                    //             let nMinIndex:any = 0;
                                    //             for (let i=arrayKeys.length -1;i >= 0;i--){
                                    //                 if (newRowCheck[arrayKeys[i]] && arrayKeys[i] < rowIndex){
                                    //                     nMinIndex = arrayKeys[i];
                                    //                     break;
                                    //                 }
                                    //             }
                                    //             for (let i=nMinIndex;i<rowIndex;i++){
                                    //                 newRowCheck[i] = true;
                                    //             }
                                    //         }
                                    //         setRowChecked(newRowCheck);
                                    //         //如果有选择的，就显示选项
                                    //         props.onRefreshCheck(newRowCheck)
                                    //      }}
                                    // />
                                }
                                {flexRender(cell.column.columnDef.cell, cell.getContext())}

                                <div className={'flex-row-vertical-center'} style={{marginLeft:'auto',position:'absolute',right:'4px'}}>
                                    {
                                        row.original.type == 'row' &&
                                        <>
                                        {
                                            false &&
                                            <Tooltip arrow={false} title={t(row.original.link?"Change link":"LinkToCard")}>
                                                <img className={'img-24 cursor-pointer ml-4 operator-icon'}
                                                     src={getImagePathWithThemeSvg(row.original.link?'tableview_change_link':'tableview_link_to')} onClick={(e)=>{
                                                    window.showDialogLink(row.original.link || '', 'card', async (item) => {
                                                        row.original.link = item;
                                                        if (isDeepLink(item)){
                                                            const deeplink = decodeDeeplink(item);
                                                            let deeplinkItem:any = null;
                                                            if (deeplink.type == 'project'){
                                                                deeplinkItem = await getNoteById(deeplink.id);
                                                            }else{
                                                                deeplinkItem = await getCardById(deeplink.id);
                                                            }
                                                            if (deeplinkItem.type == 'card'){
                                                                row.original.name = getCardTitle(deeplinkItem);
                                                            }else{
                                                                row.original.name = deeplinkItem?.name || '';
                                                            }

                                                        }
                                                        updateItem(row).then(res=>{
                                                            refreshSingleData(row.original.id,null);
                                                        });
                                                    });
                                                }}/>
                                            </Tooltip>
                                        }

                                            {
                                                !row.original.link &&
                                                <Tooltip arrow={false} title={t("TurnToNewCard")}>
                                                    <img className={'img-24 cursor-pointer ml-4 operator-icon'}
                                                         src={getImagePathWithTheme('tableview_turn_to_card.svg')} onClick={async (e)=>{
                                                        // const item = {
                                                        //     id:generateUUID2(),
                                                        //     isDeleted:0,
                                                        //     type:'card',
                                                        //     createTime:Date.now(),
                                                        //     updateTime:Date.now(),
                                                        //     tags:[],
                                                        //     name:row.original.name,
                                                        // }
                                                        // await updateCard(item);
                                                        //更新这个row...

                                                        row.original.doc = `<p data-id="${generateUUID2()}" ifhidden="false" class="has-focus">${row.original.name.replaceAll('\n','<br class="ProseMirror-trailingBreak">')}</p>`
                                                        row.original.type = 'card';
                                                        row.original.name = '';
                                                        updateItem(row).then(res=>{
                                                            refreshSingleData(row.original.id,null);
                                                        });
                                                    }}/>
                                                </Tooltip>
                                            }
                                        </>

                                    }

                                    {
                                        (isCanLocate() || isDeeplinkLocate()) &&
                                        <Tooltip arrow={false} title={t("Locate")}>
                                            <img className={'img-24 cursor-pointer ml-4 operator-icon'}
                                                 src={getImagePathWithTheme('tableview_item_locate.svg')} onClick={async (e)=>{
                                                     let item = row.original;
                                                     if (item.type == 'row'){
                                                         const deeplink = decodeDeeplink(item.link);
                                                         item = await getCardById(deeplink.id);
                                                     }
                                                postMessage(EVENT_OPEN_LIBRARY_ITEM,{...item,openInDialogAnno:false,deeplink:createCopyLinkByLibraryItem(item,false)})
                                            }}/>
                                        </Tooltip>
                                    }

                                    {
                                        isCanOpenIsSlider() &&
                                        <Tooltip arrow={false} title={t("Add to sidebar")}>
                                            <img className={'img-24 cursor-pointer  ml-4 operator-icon'}
                                                 src={getImagePathWithThemeSvg('tableview_item_open_in_slider')} onClick={async (e)=>{
                                                     //右侧栏打开...
                                                        let item = row.original;
                                                        if (item.type == 'row'){
                                                            if (!item.link)return;

                                                            if (isDeepLink(item.link)){
                                                                const deeplink = decodeDeeplink(item.link);
                                                                if (deeplink.type == 'project'){
                                                                    item = await getNoteById(deeplink.id);
                                                                }else {
                                                                    item = await getCardById(deeplink.id);
                                                                }
                                                            }else {
                                                                let szUrl = item.link;
                                                                openUrlOrLocalPath(szUrl);
                                                                return;
                                                            }
                                                        }

                                                        if (item.type == 'project'){
                                                            postMessage(EVENT_SHOW_DIALOG_DRAWINDEX,{inSlider:true,linkInfo:{id:item.id},})
                                                        }else if (item.type == 'board'){
                                                            postMessage(EVENT_SHOW_DIALOG_DRAWINDEX,{inSlider:true,linkInfo:{id:item.projectId,pageId:item.id},})
                                                        }
                                                        else{
                                                            postMessage(EVENT_OPEN_LIBRARY_ITEM,{inSlider:true,id:item.id})
                                                        }
                                            }}/>
                                        </Tooltip>
                                    }
                                    {
                                        !isRowOtherLink() &&
                                        <Tooltip arrow={false} title={t("Info")}>
                                            <img className={'img-24 cursor-pointer ml-4 operator-icon'}
                                                 src={getImagePathWithThemeSvg('tableview_item_info')} onClick={(e)=>{
                                                if (row.original.type == 'project'){
                                                    window.showInfo('project',row.original);
                                                }else if (row.original.type == 'board'){
                                                    window.showInfo('project',row.original);
                                                }
                                                else{
                                                    window.showInfo('library',row.original);
                                                }
                                            }}/>
                                        </Tooltip>
                                    }

                                    {
                                        !isRowOtherLink() &&
                                        <Dropdown trigger={['click']} open={mapIsColumnMoreOpen[`column-more-${row.original.id}`]}
                                                  onOpenChange={(e) => {
                                                      mCurrentMoreData.current = row.original;
                                                      //要改菜单的地方太多了。DYAMIC
                                                      reContextMenu(e,row.original);
                                                      const newMap = {...mapIsColumnMoreOpen};
                                                      //全部隐藏。
                                                      const arrayKeys = Object.keys(newMap);
                                                      arrayKeys.forEach(pp=>{
                                                          newMap[pp] = false;
                                                      })
                                                      newMap[`column-more-${row.original.id}`] = e;
                                                      setMapIsColumnMoreOpen(newMap);
                                                      setTimeout(() => {
                                                          patchMenuFavor(row.original);
                                                      }, 50)
                                                  }} menu={{items: menuItems, onClick: handleMenuClick}} overlayStyle={{minWidth:'160px'}}>
                                            <Tooltip arrow={false} title={t("More")}>
                                                <img className={'img-24 cursor-pointer ml-4 operator-icon'}
                                                     src={getImagePathWithThemeSvg('tableview_item_more')}/>
                                            </Tooltip>
                                        </Dropdown>
                                    }


                                </div>

                            </div> : <>
                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                            </>
                    }
                </td>
            </>
        )
    }


    return <DndContext
        collisionDetection={closestCenter}
        modifiers={[restrictToHorizontalAxis]}
        onDragStart={handleDragStart}
        onDragMove={handleDragMove}
        onDragOver={handleDragOver}
        onDragEnd={handleDragEnd}
        sensors={sensors}
    >
        <div
             style={{maxHeight: '100%', marginTop: '20px', overflow: 'hidden',height:'100%',}}>
            {/* 虚拟滚动容器 - 单独分离出来 */}
            <div
                ref={divTableContainerRef}
                style={{
                    height: 'calc(100% - 0px)', // 减去表头高度
                    overflow: 'auto',
                    position: 'relative'
                }}>

                <table cellSpacing={'0'} cellPadding={'0'} className={'table-view-container'} {...{
                    style: {
                        // width: table.getCenterTotalSize(),
                        position: 'relative',
                    },
                }}>
                    <thead style={{position:'sticky',top:'0px',background:'var(--table-view-header-background-color)',zIndex:'9',boxShadow:'0 0 0 0.5px var(--table-view-border-color)'}}>
                    {table.getHeaderGroups().map(headerGroup => (
                        <tr key={headerGroup.id} style={{ borderLeft:'0px solid var(--table-view-border-color)',borderTop:'0.5px solid var(--table-view-border-color)',}}>
                            <SortableContext
                                items={columnOrder}
                                strategy={horizontalListSortingStrategy}
                            >
                                {headerGroup.headers.map(header => (
                                    <DraggableTableHeader key={header.id} header={header}/>
                                ))}
                            </SortableContext>
                        </tr>
                    ))}
                    </thead>
                    {/*<div style={{overflow: 'auto',}}>*/}
                    <tbody ref={divTableContainerRef} style={{height: totalSize, position: 'relative', width: '100%', }}>
                    {virtualRows.map((virtualRow) => {
                        const row = table.getRowModel().rows[virtualRow.index];
                        return <tr key={row.id} className={'tr-style'} style={{
                            position: 'absolute',
                            top: `${virtualRow.start}px`,
                            left: 0,
                            width: '100%',
                            height: `${virtualRow.size}px`,
                            borderLeft:'0px solid var(--table-view-border-color)',
                            // transform: `translateY(${virtualRow.start}px)`,
                            // display: 'flex',
                            // alignItems: 'center',
                            // zIndex:'0'
                            // borderBottom: '1px solid #eee',
                            // backgroundColor: virtualRow.index % 2 ? '#f9f9f9' : 'white',
                        }}>
                            {row.getVisibleCells().map(cell => (
                                <SortableContext
                                    key={cell.id}
                                    items={columnOrder}
                                    strategy={horizontalListSortingStrategy}
                                >
                                    <DragAlongCell key={cell.id} cell={cell} row={row} rowIndex={virtualRow.index}/>
                                </SortableContext>
                            ))}
                        </tr>
                    })}

                    {/* 底部 padding */}
                    {/*{paddingBottom > 0 && <div style={{height: paddingBottom}}/>}*/}
                    {
                        // table.getRowModel().rows.map((row,rowIndex) => (
                        // <tr key={row.id} className={'tr-style'}>
                        //     {row.getVisibleCells().map(cell => (
                        //         <SortableContext
                        //             key={cell.id}
                        //             items={columnOrder}
                        //             strategy={horizontalListSortingStrategy}
                        //         >
                        //             <DragAlongCell key={cell.id} cell={cell} row={row} rowIndex={rowIndex}/>
                        //         </SortableContext>
                        //     ))}
                        // </tr>
                        // ))
                    }

                    </tbody>

                    {/*帖一个div做为左边的边框*/}
                    <div style={{position:'absolute',top:'0px',height:'100%',zIndex:'99',width:'1px',background:'var(--table-view-border-color)'}}></div>

                    {/*</div>*/}
                </table>

                <Dropdown overlayClassName='default-dropdown-style'
                          overlayStyle={{minWidth: '232px'}}
                          menu={{items: ARRAY_PROPERTY_ADD_ITEM()}}
                          trigger={['click']}>
                    <div className={'flex-row-vertical-center mt-10 cursor-pointer'} style={{paddingLeft:'12px',marginBottom:'12px'}}>
                        <img className={'img-16'} src={getImagePathWithTheme('add_gray_1.svg')}/>
                        <span className={'ml-4'} style={{color:'var(--color-9A9A9A)'}}>{t('New content')}</span>
                    </div>
                </Dropdown>

            </div>


            <Spin style={{position: 'absolute', left: '50%', height: '50px', width: '50px', top: '156px'}}
                  indicator={IconIndicatorBlue} spinning={isLoading}/>
        </div>
    </DndContext>
})


export default React.memo(TableView);